/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient, HttpResponse, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  callLogKeys,
  getFilter,
  getCountWhere,
  receivingNumberKeys,
  sipGatewayKeys,
  trackingKeys,
  userKeys,
  callLogKeysForSupport,
  customerKeys,
  roleKeys,
  whiteListKeys,
  apiKeys,
} from '@app/helper/utils';
import { Observable, forkJoin, of, throwError } from 'rxjs';
import { map, tap, timeout, switchMap, catchError } from 'rxjs/operators';
import { StoreService } from '../store/store.service';
import { ICustomer, IRole, IUser, IUserLogin, IUserToken } from 'src/app/models/user';
import {
  ITicket,
  ITicketAsset,
  ITicketAttachment,
  ITicketNotification,
  ITicketObserver,
  ITicketOwner,
  IticketState,
  ITicketVersion,
} from 'src/app/models/tickets';
import { IService } from 'src/app/models/service';
import { GetNumbers, GetSources } from 'src/app/models/tracking_numbers';
import {
  CallLog,
  CallLogSupport,
  CallRecording,
  LightLog,
  PhoneBook,
  LogsCount,
  IBlacklistNumber,
} from 'src/app/models/callLog';
import { ReceivingNumber } from 'src/app/models/receiving-number';
import { SipGateways } from '@app/models/sip-gateway';
import { GuiPermission, GuiSection, GuiVisibility } from '@app/models/gui';
import { RoutingAction } from '../../models/routing-action';
import { trackingSourceKeys } from '../../helper/utils';
import { environment } from '@env/environment';
import { Calls } from '@app/models/calls';
import {
  CallTraceCursors,
  CallTraceFilter,
  CallTracePacketResult,
  CallTraceSearchResult,
  CallTraceWatchResult,
} from '@app/models/call-trace';
import { PaymentFilters, PaymentQueryI } from '@app/models/payment-history';
import { IVR } from '@app/modules/client/ivr/ivr.interface';
import { WhiteList } from '@app/models/white-list';
import { TNX_PRODUCT_MAP } from '@app/modules/client/constant';
import { accessRole } from '@app/models/access-role';
import { ToastrService } from '../toastr/toastr.service';

export interface DatabaseBackupConfiguration {
  enabled: boolean;
  bucket?: string;
  endpoint?: string;
  region: string;
  forcePathStyle: boolean;
  filename: string;
  filenames?: { full: string; call_logs: string; sipcapture: string };
  cron: string;
}

export interface ExtensionRecord {
  id: number;
  customerId: number;
  number: string;
  name: string;
  avatar?: string | null;
  outboundNumberId?: number | null;
  outboundNumber?: string | null;
  deviceType: 'softphone' | 'ip_phone';
  enabled: boolean;
  configured: boolean;
  registered?: boolean;
  registrationState?: 'connected' | 'disconnected' | 'unknown';
  sourceIp?: string | null;
  username: string;
  domain: string;
  sipServer?: string | null;
  sipPort?: number;
  webSocketUrl?: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  getPlatformBillingPolicy() {
    return this.http.get<any>(this.coreApi + '/Customers/platformBillingPolicy');
  }

  savePlatformBillingPolicy(policy: object) {
    return this.http.post<any>(this.coreApi + '/Customers/savePlatformBillingPolicy', policy);
  }

  getAccountServiceRates(customerId: number) {
    return this.http.get<{ currency: string; rates: any[] }>(
      this.coreApi + '/Customers/accountServiceRates?customerId=' + customerId
    );
  }
  saveAccountBillingSettings(customerId: number, settings: object) {
    return this.http.post<any>(
      this.coreApi + '/Customers/saveAccountBillingSettings?customerId=' + customerId,
      settings
    );
  }

  saveAccountPaymentMethod(customerId: number, paymentMethod: object) {
    return this.http.post<any>(
      this.coreApi + '/Customers/saveAccountPaymentMethod?customerId=' + customerId,
      paymentMethod
    );
  }

  saveAccountServiceRates(customerId: number, rates: object[]) {
    return this.http.post<any[]>(this.coreApi + '/Customers/saveAccountServiceRates?customerId=' + customerId, rates);
  }

  saveAccountServiceRate(customerId: number, rate: object) {
    return this.http.post<any>(this.coreApi + '/Customers/saveAccountServiceRate?customerId=' + customerId, rate);
  }

  private coreApi: string;

  getClusterStatus(): Observable<{
    enabled: boolean;
    clustered: boolean;
    selfId: string;
    nodes: { id: string; location: string; self: boolean }[];
    links: { from: string; to: string; status: string }[];
  }> {
    return this.http.get<any>(`${this.baseUrl}/cluster`);
  }

  preflightCustomerMigration(
    customerId: number,
    targetId: string,
    options: Record<string, boolean>,
    checkId: string
  ): Observable<any> {
    const url = `${this.baseUrl}/cluster/customer-migrations/preflight`;
    return this.http
      .post(url, { customerId, targetId, options, checkId }, { responseType: 'text' })
      .pipe(map(response => this.parseClusterResponse(response, url)));
  }

  getCustomerMigrationPreflight(checkId: string): Observable<any> {
    const url = `${this.baseUrl}/cluster/customer-migrations/preflight/${checkId}`;
    return this.http.get(url, { responseType: 'text' }).pipe(map(response => this.parseClusterResponse(response, url)));
  }

  private parseClusterResponse(response: string, url: string): any {
    try {
      return JSON.parse(response);
    } catch {
      const preview = response.trim().slice(0, 160).replace(/\s+/g, ' ');
      throw new Error(`${url} returned non-JSON content${preview ? `: ${preview}` : '.'}`);
    }
  }

  startCustomerMigration(customerId: number, targetId: string, options: Record<string, boolean>): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/cluster/customer-migrations`, { customerId, targetId, options });
  }

  getCustomerMigrations(): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/cluster/customer-migrations`);
  }

  cancelCustomerMigration(id: string): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/cluster/customer-migrations/${id}/cancel`, {});
  }

  getExtensions(customerId?: number): Observable<ExtensionRecord[]> {
    const suffix = customerId ? `?customerId=${customerId}` : '';
    return this.http.get<ExtensionRecord[]>(`${this.coreApi}/Extensions${suffix}`);
  }

  getExtensionOutboundNumbers(customerId?: number): Observable<{ id: number; number: string }[]> {
    const suffix = customerId ? `?customerId=${customerId}` : '';
    return this.http.get<{ id: number; number: string }[]>(`${this.coreApi}/Extensions/outbound-numbers${suffix}`);
  }

  createExtension(data: Partial<ExtensionRecord>): Observable<ExtensionRecord> {
    return this.http.post<ExtensionRecord>(`${this.coreApi}/Extensions`, data);
  }

  updateExtension(id: number, data: Partial<ExtensionRecord>): Observable<ExtensionRecord> {
    return this.http.put<ExtensionRecord>(`${this.coreApi}/Extensions/${id}`, data);
  }

  deleteExtension(id: number, customerId?: number): Observable<any> {
    return this.http.delete(`${this.coreApi}/Extensions/${id}${customerId ? `?customerId=${customerId}` : ''}`);
  }

  pairExtension(
    id: number,
    customerId?: number
  ): Observable<{ code?: string; expiresInSeconds?: number; configuration?: any }> {
    return this.http.post<{ code?: string; expiresInSeconds?: number; configuration?: any }>(
      `${this.coreApi}/Extensions/${id}/pair${customerId ? `?customerId=${customerId}` : ''}`,
      {}
    );
  }

  getExtensionStatus(
    id: number,
    customerId?: number
  ): Observable<{
    registered: boolean | null;
    registrationState: 'connected' | 'disconnected' | 'unknown';
    sourceIp: string | null;
  }> {
    return this.http.get<{
      registered: boolean | null;
      registrationState: 'connected' | 'disconnected' | 'unknown';
      sourceIp: string | null;
    }>(`${this.coreApi}/Extensions/${id}/status${customerId ? `?customerId=${customerId}` : ''}`);
  }

  constructor(
    private http: HttpClient,
    private store: StoreService,
    private toastrService: ToastrService
  ) {
    this.initializeCoreApi(environment);
  }

  /**
   * Initialize core API URL based on environment
   */
  private initializeCoreApi(env): void {
    this.coreApi = `${env.api.core.uri}${env.api.core.path}`;
  }

  /**
   * Get core API URL
   */
  get baseUrl(): string {
    return this.coreApi;
  }

  getDatabaseBackupConfiguration(): Observable<DatabaseBackupConfiguration> {
    return this.http.get<DatabaseBackupConfiguration>(`${this.coreApi}/database-backups/configuration`);
  }

  getDatabaseBackups(): Observable<any[]> {
    return this.http.get<any[]>(`${this.coreApi}/database-backups`);
  }

  getDatabaseBackup(id: number): Observable<any> {
    return this.http.get<any>(`${this.coreApi}/database-backups/${id}`);
  }

  runDatabaseBackup(): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/database-backups/run`, {});
  }

  cancelDatabaseBackup(id: number): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/database-backups/${id}/cancel`, {});
  }

  getCallTraces(filter: CallTraceFilter): Observable<CallTraceSearchResult> {
    const params = new HttpParams().set('filter', JSON.stringify(filter));
    return this.http.get<CallTraceSearchResult>(`${this.coreApi}/CallTraces/search`, { params });
  }

  watchCallTraces(cursors: CallTraceCursors): Observable<CallTraceWatchResult> {
    const params = new HttpParams()
      .set('afterSignal', String(cursors.signal))
      .set('afterWire', String(cursors.wire))
      .set('afterCdr', String(cursors.cdr));
    return this.http.get<CallTraceWatchResult>(`${this.coreApi}/CallTraces/watch`, { params });
  }

  getCallTracePackets(
    callId: string,
    afterWireId?: number,
    limit = 100,
    includeRtp = false,
    afterRtpId = 0
  ): Observable<CallTracePacketResult> {
    let params = new HttpParams().set('callId', callId).set('limit', String(limit));
    if (afterWireId !== undefined) params = params.set('afterWireId', String(afterWireId));
    if (includeRtp) params = params.set('includeRtp', 'true').set('afterRtpId', String(afterRtpId));
    return this.http.get<CallTracePacketResult>(`${this.coreApi}/CallTraces/packets`, { params });
  }

  getCallTraceAudio(callId: string, recording: string): Observable<Blob> {
    const params = new HttpParams().set('callId', callId).set('recording', recording);
    return this.http.get(`${this.coreApi}/CallTraces/audio`, { params, responseType: 'blob' });
  }

  dropCallTrace(callId: string): Observable<{ ended: boolean }> {
    return this.http.post<{ ended: boolean }>(`${this.coreApi}/CallTraces/drop`, { callId });
  }

  placeDiagnosticCall(payload: {
    callingNumber: string;
    calledNumber: string;
    durationSeconds: number;
    customerId?: number;
  }): Observable<{ callId: string }> {
    return this.http.post<{ callId: string }>(`${this.coreApi}/CallTraces/testCall`, payload);
  }

  /**
   * Update the base path from environment
   */
  public setBasePath(env): void {
    this.initializeCoreApi(env);
  }

  // =============================
  // Authentication & User Methods
  // =============================

  /**
   * User login
   */
  public login(data: IUserLogin, rememberedIf: boolean): Observable<object> {
    return this.http.post<IUserToken>(`${this.coreApi}/DashUsers/authenticate`, data).pipe(
      tap(token => {
        // @ts-ignore
        const statusCodes = [400, 401, 403, 404, 500];
        // @ts-ignore
        if (token?.id && !statusCodes.includes(token.statusCode)) {
          this.store.storeToken({ ...token, rememberedIf });
        }
      }),
      map(token => token)
    );
  }

  public securityStatus(): Observable<{
    totpEnabled: boolean;
    recoveryCodesRemaining: number;
    passkeys: { id: string; label: string; createdAt: string; lastUsedAt: string }[];
  }> {
    return this.http.get<any>(`${this.coreApi}/DashUsers/security/status`);
  }

  public securityAction(path: string, input: object): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/DashUsers/security/${path}`, input);
  }

  public passkeyLoginBegin(): Observable<{ flow: string; options: any }> {
    return this.http.post<any>(`${this.coreApi}/DashUsers/passkey/begin`, {});
  }

  public passkeyLoginFinish(flow: string, response: object, rememberedIf: boolean): Observable<IUserToken> {
    return this.http.post<IUserToken>(`${this.coreApi}/DashUsers/passkey/finish`, { flow, response }).pipe(
      tap(token => {
        if (token?.id) this.store.storeToken({ ...token, rememberedIf });
      })
    );
  }

  /**
   * Retrieve logged user as Observable
   */
  public retrieveLoggedUserOb(token: IUserToken): Observable<IUser> {
    return this.getUser(token.userId).pipe(
      switchMap(user => {
        // A user can have historical mappings. Keep the role that issued this
        // session first so navigation and API permissions describe the same role.
        const roleId = Number((token as any).roleMapping?.roleId);
        const mappings = user.DashRoleMapping || [];
        const selected = Number.isInteger(roleId) ? mappings.find(mapping => Number(mapping.roleId) === roleId) : null;
        if (selected) user.DashRoleMapping = [selected, ...mappings.filter(mapping => mapping !== selected)];
        const mapping = user.DashRoleMapping?.[0];
        if (!mapping || mapping.DashRole?.['GuiVisibilities']?.length) return of(user);
        return this.getGuiVisibilitiesByFilter(JSON.stringify({ where: { roleId: mapping.roleId } })).pipe(
          map(visibility => {
            if (mapping.DashRole) mapping.DashRole['GuiVisibilities'] = visibility;
            return user;
          }),
          catchError(() => of(user))
        );
      }),
      tap(user => {
        this.store.storeUser(user);
        const role = accessRole(user);
        this.store.setUserPermissions({ isSuperAdmin: role === 'SAdmin', isCustomerAdmin: role === 'Admin' });
        this.store.setGuiVisibility(user.DashRoleMapping?.[0]?.DashRole?.['GuiVisibilities'] || []);
        if (role !== 'SAdmin' && user.Customer?.enabled === 0) {
          this.toastrService.showWarning('Your account is currently deactivated. Please update your payment details.');
        }
      })
    );
  }

  /**
   * Retrieve logged user as Promise
   */
  public retrieveLoggedUser(token: IUserToken): Promise<void> {
    return new Promise(resolve => {
      this.getUser(token.userId).subscribe(
        user => {
          if (user) {
            this.store.storeUser(user);
          }
        },
        err => {
          /* TODO */
        },
        () => {
          resolve();
        }
      );
    });
  }

  /**
   * User logout
   */
  public logout(): Observable<any> {
    return this.http.post(`${this.coreApi}/DashUsers/logout`, null);
  }

  /**
   * Activate user account
   */
  public accountActivate(token): Observable<any> {
    return this.http.get(`${this.coreApi}/DashUsers/activate/token=${token}`);
  }

  /**
   * Check permissions
   */
  public getCanI(data): Observable<any> {
    return this.http.post(`${this.coreApi}/DashUsers/cani`, data);
  }

  // ====================
  // User Management APIs
  // ====================

  /**
   * Get user by ID
   */
  getUser(id: number): Observable<IUser> {
    return this.http.get<IUser>(`${this.coreApi}/DashUsers/${id}`);
  }

  getSoftphoneConfig(): Observable<any> {
    return this.http.get<any>(`${this.coreApi}/DashUsers/softphone-config`);
  }

  /**
   * Update user
   */
  updateUser(data: IUser): Observable<IUser> {
    return this.http.patch<IUser>(`${this.coreApi}/DashUsers/${data.id}`, data);
  }

  /**
   * Update user role
   */
  updateUserRole(userId: number, roleId: number): Observable<IUser> {
    return this.http.post<any>(`${this.coreApi}/DashUsers/${userId}/role`, { role_id: roleId });
  }

  /**
   * Update user password
   */
  updateUserPassword(userid: number, newPassword: string): Observable<any> {
    const data = {
      id: userid,
      password: newPassword,
    };
    return this.http.patch<IUser>(`${this.coreApi}/DashUsers/${userid}`, data);
  }

  /**
   * Reset user account
   */
  accountReset(userid: number): Observable<any> {
    return this.http.get<boolean>(`${this.coreApi}/DashUsers/${userid}/account-reset`);
  }

  /**
   * Request password reset
   */
  forgotPassword(email: string): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/DashUsers/forgot-password`, { email: email });
  }

  /**
   * Get users list with filter
   */
  getUsers(filter?: string): Observable<IUser[]> {
    const filters = encodeURIComponent(filter);
    return this.http.get<any>(`${this.coreApi}/DashUsers?filter=${filters}`);
  }

  /**
   * Get several users by ID list
   */
  getSeveralUsers(strUserIds?: string): Observable<IUser[]> {
    return this.http.post<any>(`${this.coreApi}/DashUsers/several_user`, { ids: strUserIds });
  }

  /**
   * Get total count of users
   */
  getUserCount(filterValue: string, customerFilter?: any): Observable<any> {
    const whereParam = getCountWhere(filterValue, null, null, userKeys, customerFilter);
    return this.http.get<any>(`${this.coreApi}/DashUsers/count?${'where=' + whereParam}`);
  }

  /**
   * Get roles by filter
   */
  getRolesByFilter(filter?: string): Observable<any> {
    return this.http.get<any>(`${this.coreApi}/DashRoles?filter=${filter}`);
  }

  /**
   * Get all roles
   */
  getRoles(): Observable<any> {
    return this.http.get<any>(`${this.coreApi}/DashRoles`);
  }

  /**
   * Get verification tokens
   */
  verificationTokens(filter: any): Observable<any> {
    return this.http.get<any>(`${this.coreApi}/DashUsers/verification_tokens?filter=${filter}`);
  }

  /**
   * Get total count of roles
   */
  getRoleCount(filterValue: string, customerFilter?: any): Observable<any> {
    const whereParam = getCountWhere(filterValue, null, null, roleKeys, customerFilter);
    return this.http.get<any>(`${this.coreApi}/DashRoles/count?${'where=' + whereParam}`);
  }

  /**
   * Add new user
   */
  addUser(data: any): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/DashUsers`, data);
  }

  /**
   * Impersonate another user
   */
  impersonateUser(userId: number): Observable<any> {
    return this.http.post(`${this.coreApi}/DashUsers/impersonate`, { user_id: userId });
  }

  /**
   * Stop impersonating
   */
  deimpersonate(tokenId: string): Observable<any> {
    return this.http.post(`${this.coreApi}/DashUsers/deimpersonate`, { token_id: tokenId });
  }

  /**
   * Check if user attribute is unique
   */
  isUserUnique(attribute: string, value: string): Observable<any> {
    return this.http.post<boolean>(`${this.coreApi}/DashUsers/isunique`, { column: attribute, pattern: value });
  }

  // =====================
  // Customer Management
  // =====================

  /**
   * Get customers list with filtering
   */
  getCustomersList(
    active: string,
    direction: string,
    page: number,
    size: number,
    filterName: string,
    filterValue: string,
    customerFilter?: any
  ): Observable<ICustomer[]> {
    const filter = getFilter(
      active,
      direction,
      size,
      page,
      filterValue,
      null,
      null,
      customerKeys,
      undefined,
      customerFilter
    );
    const url = `${this.coreApi}/Customers?${filter !== 'filter=' ? filter + '&' : ''}`;
    return this.http.get<ICustomer[]>(url);
  }

  /**
   * Get total count of customers
   */
  getCustomerCount(filterValue: string, customerFilter?: any): Observable<any> {
    const whereParam = getCountWhere(filterValue, null, null, customerKeys, customerFilter);
    return this.http.get<any>(`${this.coreApi}/Customers/count?${'where=' + whereParam}`);
  }

  /**
   * Add new customer
   */
  addCustomer(data: ICustomer): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/Customers`, data);
  }

  /**
   * Get customer by ID
   */
  getCustomer(id: number): Observable<ICustomer> {
    const url = `${this.coreApi}/Customers/${id}`;
    return this.http.get<ICustomer>(url);
  }

  /**
   * Update customer
   */
  setCustomerArchive(id: number, action: 'ARCHIVE' | 'RESTORE'): Observable<boolean> {
    return this.http.post<boolean>(this.coreApi + '/Customers/set_archive', { id, action });
  }

  setCustomerEnabled(id: number, enabled: boolean): Observable<boolean> {
    return this.http.post<boolean>(this.coreApi + '/Customers/set_status', { customer: { id }, enabled });
  }

  updateCustomer(data: ICustomer): Observable<ICustomer> {
    return this.http.put<ICustomer>(`${this.coreApi}/Customers`, data);
  }

  /**
   * Update auto-recharge settings for current customer
   */
  updateAutoRechargeSettings(settings: any): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/PaymentMethods/update_auto_recharge_settings`, settings);
  }

  /**
   * Delete customer by ID
   */
  deleteCustomer(id: number): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/Customers/delete_customer`, { id });
  }

  /**
   * @deprecated Use deleteCustomer() instead.
   */
  deleteCustomerById(id: number): Observable<any> {
    return this.deleteCustomer(id);
  }

  /**
   * Get all customers list
   */
  getAllCustomerList(): Observable<ICustomer[]> {
    const url = `${this.coreApi}/Customers`;
    return this.http.get<ICustomer[]>(url);
  }

  /**
   * Get customer balance
   */
  getCustomerBalance(): Observable<any> {
    return this.http.get<any>(`${this.coreApi}/PaymentMethods/balance`);
  }

  /**
   * Check if customer has primary payment method
   */
  hasPrimaryMethod(): Observable<any> {
    return this.http.get<any>(`${this.coreApi}/PaymentMethods/has_primary_method`);
  }

  /**
   * Refund transaction
   */
  refundTransaction(data: ICustomer, transactionId: number, amount: number): Observable<any> {
    return this.http.put<any>(`${this.coreApi}/PaymentMethods/refund`, { customerId: data.id, transactionId, amount });
  }

  /**
   * Create invoice for transaction
   */
  invoiceTransaction(data: ICustomer, transactionId: number): Observable<any> {
    return this.http.put<any>(`${this.coreApi}/PaymentMethods/invoice`, { customerId: data.id, transactionId });
  }

  // =====================
  // Language Management
  // =====================

  /**
   * Get all languages
   */
  getLanguages(): Observable<any> {
    return this.http.get<any>(`${this.coreApi}/Languages?filter[order]=name`);
  }

  // =====================
  // Ticket Management
  // =====================

  /**
   * Get tickets with filters
   */
  getTickets(filters: string = ''): Observable<ITicket[]> {
    return this.http.get<ITicket[]>(`${this.coreApi}/tickets${filters}`);
  }

  /**
   * Get ticket by ID
   */
  getTicket(id: number): Observable<ITicket> {
    return this.http.get<ITicket>(`${this.coreApi}/tickets/${id}`);
  }

  /**
   * Add new ticket
   */
  addTicket(ticket: ITicket): Observable<ITicket> {
    return this.http.post<ITicket>(`${this.coreApi}/tickets`, ticket);
  }

  /**
   * Get latest ticket version
   */
  getLatestVersion(ticketId: number): Observable<ITicketVersion> {
    return this.http.get<ITicketVersion>(`${this.coreApi}/versions/latest?tid=${ticketId}&`);
  }

  /**
   * Get ticket versions
   */
  getTicketVersions(id: number): Observable<ITicketVersion[]> {
    return this.http.get<ITicketVersion[]>(`${this.coreApi}/tickets/${id}/versions`);
  }

  /**
   * Get specific ticket version
   */
  getTicketVersion(ticketId: number, versionId: number): Observable<ITicketVersion> {
    return this.http.get<ITicketVersion>(`${this.coreApi}/tickets/${ticketId}/versions/${versionId}`);
  }

  /**
   * Update ticket version
   */
  updateTicketVersion(ticketId: number, version: ITicketVersion): Observable<ITicketVersion> {
    return this.http.post<ITicketVersion>(`${this.coreApi}/tickets/${ticketId}/versions`, version);
  }

  /**
   * Get ticket owner
   */
  getTicketOwner(ticketId: number, versionId: number): Observable<ITicketOwner> {
    return this.http.get<ITicketOwner>(`${this.coreApi}/tickets/${ticketId}/versions/${versionId}/owner`);
  }

  /**
   * Get ticket state
   */
  getTicketState(ticketId: number, versionId: number): Observable<IticketState> {
    return this.http.get<IticketState>(`${this.coreApi}/tickets/${ticketId}/versions/${versionId}/state`);
  }

  /**
   * Get ticket assets
   */
  getTicketAssets(ticketId: number, versionId: number): Observable<ITicketAsset[]> {
    return this.http.get<ITicketAsset[]>(`${this.coreApi}/tickets/${ticketId}/versions/${versionId}/assets`);
  }

  /**
   * Get specific ticket asset
   */
  getTicketAsset(ticketId: number, versionId: number, assetId: number): Observable<ITicketAsset> {
    return this.http.get<ITicketAsset>(`${this.coreApi}/tickets/${ticketId}/versions/${versionId}/assets/${assetId}`);
  }

  /**
   * Get ticket attachments
   */
  getTicketAttachments(ticketId: number, versionId: number): Observable<ITicketAttachment[]> {
    return this.http.get<ITicketAttachment[]>(`${this.coreApi}/tickets/${ticketId}/versions/${versionId}/attachments`);
  }

  /**
   * Get specific ticket attachment
   */
  getTicketAttachment(ticketId: number, versionId: number, attachId: number): Observable<ITicketAttachment> {
    return this.http.get<ITicketAttachment>(
      `${this.coreApi}/tickets/${ticketId}/versions/${versionId}/attachments/${attachId}`
    );
  }

  /**
   * Add attachment to ticket
   */
  addAttachment(n: ITicketAttachment, ticketId: number): Observable<ITicketAttachment> {
    return this.http.post<ITicketAttachment>(
      `${this.coreApi}/tickets/${ticketId}/versions/${n.versionId}/attachments`,
      n
    );
  }

  /**
   * Get ticket notifications
   */
  getTicketNotifications(ticketId: number, versionId: number): Observable<ITicketNotification[]> {
    return this.http.get<ITicketNotification[]>(
      `${this.coreApi}/tickets/${ticketId}/versions/${versionId}/notifications`
    );
  }

  /**
   * Add notification to ticket
   */
  addNotification(n: ITicketNotification, ticketId: number): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/tickets/${ticketId}/versions/${n.versionId}/notifications`, n);
  }

  /**
   * Get specific ticket notification
   */
  getTicketNotification(ticketId: number, versionId: number, notifId: number): Observable<ITicketNotification> {
    return this.http.get<ITicketNotification>(
      `${this.coreApi}/tickets/${ticketId}/versions/${versionId}/notifications/${notifId}`
    );
  }

  /**
   * Get ticket observers
   */
  getTicketObservers(ticketId: number, versionId: number, filters?: string): Observable<ITicketObserver[]> {
    let uri = `${this.coreApi}/tickets/${ticketId}/versions/${versionId}/observers`;
    if (filters) {
      uri += `?${filters}&`;
    }
    return this.http.get<ITicketObserver[]>(uri);
  }

  /**
   * Add observer to ticket
   */
  observeTicket(ticketId: number, versionId: number, userId: number): Observable<ITicketObserver> {
    return this.http.post<ITicketObserver>(`${this.coreApi}/tickets/${ticketId}/versions/${versionId}/observers`, {
      id: 0,
      versionId,
      userId,
    });
  }

  /**
   * Remove observer from ticket
   */
  removeObservingTicket(ticketId: number, versionId: number, obId: number): Observable<ITicketObserver> {
    return this.http.delete<ITicketObserver>(
      `${this.coreApi}/tickets/${ticketId}/versions/${versionId}/observers/${obId}`
    );
  }

  /**
   * Count tickets by owner
   */
  countTicketByOwner(userId: number) {
    return this.http.get<{ count: number }>(`${this.coreApi}/tickets/count-by-owner?uid=${userId}&`);
  }

  /**
   * Count tickets by observer
   */
  countTicketByObserver(userId: number) {
    return this.http.get<{ count: number }>(`${this.coreApi}/tickets/count-by-owner?uid=${userId}&`);
  }

  /**
   * Count tickets by state
   */
  countTicketByState(stateId: 1 | 2 | 3 | 4 | 5, userId: number) {
    return this.http.get<{ count: number }>(`${this.coreApi}/tickets/count-by-state?uid=${userId}&sid=${stateId}&`);
  }

  /**
   * Count ticket observers
   */
  countTicketsObservers(ticketId: number, versionId: number) {
    return this.http.get<{ count: number }>(
      `${this.coreApi}/Tickets/${ticketId}/Versions/${versionId}/Observers/count`
    );
  }

  /**
   * Delete ticket
   */
  deleteTicket(ticketId: number) {
    return this.http.delete<{ count: number }>(`${this.coreApi}/Tickets/${ticketId}`);
  }

  /**
   * Delete tickets by condition
   */
  deleteTicketsByWhere(where: string) {
    return this.http.delete<{ count: number }>(`${this.coreApi}/Tickets?where=${where}`);
  }

  /**
   * Get tickets with filter
   */
  getTicketsByFilter(filter: string): Observable<any> {
    return this.http.get<any>(`${this.coreApi}/tickets?filter=${filter}`);
  }

  // =====================
  // Subscription Management
  // =====================

  /**
   * Get subscriptions with filter
   */
  getSubscriptionsByFilter(filter: string): Observable<any> {
    return this.http.get<any>(`${this.coreApi}/Subscriptions?filter=${filter}`);
  }

  /**
   * Delete subscription by ID
   */
  deleteSubscriptionById(id: number) {
    return this.http.delete<{ count: number }>(`${this.coreApi}/Subscriptions/${id}`);
  }

  /**
   * Delete subscriptions by condition
   */
  deleteSubscriptionsByWhere(where: string) {
    return this.http.delete<{ count: number }>(`${this.coreApi}/Subscriptions?where=${where}`);
  }

  // =====================
  // Service Provider Management
  // =====================

  /**
   * Get service providers with filter
   */
  getServiceProvidersByFilter(filter: string): Observable<any> {
    return this.http.get<any>(`${this.coreApi}/ServiceProviders?filter=${filter}`);
  }

  /**
   * Delete service provider by ID
   */
  deleteServiceProviderById(id: number) {
    return this.http.delete<{ count: number }>(`${this.coreApi}/ServiceProviders/${id}`);
  }

  /**
   * Delete service providers by condition
   */
  deleteServiceProvidersByWhere(where: string) {
    return this.http.delete<{ count: number }>(`${this.coreApi}/ServiceProviders?where=${where}`);
  }

  /**
   * Get provider numbers list
   */
  getProviderNumbersList(filter): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/NumberProviders/lookup`, filter);
  }

  /**
   * Get provider numbers list by suffix
   */
  getProviderNumbersListBySuffix(filter): Observable<any> {
    return this.http.get<any>(`${this.coreApi}/NumberProviders/suffix?${filter}`);
  }

  /**
   * Reserve provider numbers
   */
  reserveProviderNumbers(data): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/NumberProviders/reserve?`, data);
  }

  /**
   * Release provider number
   */
  releaseProviderNumber(data): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/NumberProviders/release`, data);
  }

  /**
   * Get countries
   */
  getCountries(): Observable<any> {
    return this.http.get<any>(`${this.coreApi}/NumberProviders/countries`);
  }

  /**
   * Get rate centers
   */
  getRatecenters(state): Observable<any> {
    return this.http.get<any>(`${this.coreApi}/NumberProviders/ratecenter?state=${state}`);
  }

  // =====================
  // Document Management
  // =====================

  /**
   * Get documents with filter
   */
  getDocumentsByFilter(filter: string): Observable<any> {
    return this.http.get<any>(`${this.coreApi}/Documents?filter=${filter}`);
  }

  /**
   * Delete document by ID
   */
  deleteDocumentById(id: number) {
    return this.http.delete<{ count: number }>(`${this.coreApi}/Documents/${id}`);
  }

  /**
   * Delete documents by condition
   */
  deleteDocumentsByWhere(where: string) {
    return this.http.delete<{ count: number }>(`${this.coreApi}/Documents?where=${where}`);
  }

  // =====================
  // Maintenance Management
  // =====================

  /**
   * Get maintenance records with filter
   */
  getMainteinancesByFilter(filter: string): Observable<any> {
    return this.http.get<any>(`${this.coreApi}/Mainteinances?filter=${filter}`);
  }

  /**
   * Delete maintenance by ID
   */
  deleteMainteinanceById(id: number) {
    return this.http.delete<{ count: number }>(`${this.coreApi}/Mainteinances/${id}`);
  }

  /**
   * Delete maintenance records by condition
   */
  deleteMainteinancesByWhere(where: string) {
    return this.http.delete<{ count: number }>(`${this.coreApi}/Mainteinances?where=${where}`);
  }

  // =====================
  // Asset Management
  // =====================

  /**
   * Get assets with filter
   */
  getAssetsByFilter(filter: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.coreApi}/Assets?filter=${filter}`);
  }

  /**
   * Delete asset by ID
   */
  deleteAssetById(id: number): Observable<any> {
    return this.http.delete<{ count: number }>(`${this.coreApi}/Assets/${id}`);
  }

  /**
   * Delete assets by condition
   */
  deleteAssetsByWhere(where: string) {
    return this.http.delete<{ count: number }>(`${this.coreApi}/Assets?where=${where}`);
  }

  // =====================
  // Addressee Management
  // =====================

  /**
   * Get addressees with filter
   */
  getAddressesByFilter(filter: string): Observable<any> {
    return this.http.get<any>(`${this.coreApi}/Addressees?filter=${filter}`);
  }

  /**
   * Delete addressee by ID
   */
  deleteAddressesById(id: number) {
    return this.http.delete<{ count: number }>(`${this.coreApi}/Addressees/${id}`);
  }

  /**
   * Delete addressees by condition
   */
  deleteAddressesByWhere(where: string) {
    return this.http.delete<{ count: number }>(`${this.coreApi}/Addressees?where=${where}`);
  }

  // =====================
  // Observer Management
  // =====================

  /**
   * Get observers with filter
   */
  getObserversByFilter(filter: string): Observable<any> {
    return this.http.get<{ count: number }>(`${this.coreApi}/Observers?filter=${filter}`);
  }

  /**
   * Delete observer by ID
   */
  deleteObserversById(id: number) {
    return this.http.delete<{ count: number }>(`${this.coreApi}/Observers/${id}`);
  }

  /**
   * Delete observers by condition
   */
  deleteObserversByWhere(where: string) {
    return this.http.delete<{ count: number }>(`${this.coreApi}/Observers?where=${where}`);
  }

  // =====================
  // Redis Subscription Management
  // =====================

  /**
   * Get Redis subscriptions with filter
   */
  getRedisSubscriptionsByFilter(filter: string): Observable<any> {
    return this.http.get<any>(`${this.coreApi}/RedisSubscriptions?filter=${filter}`);
  }

  /**
   * Delete Redis subscription by ID
   */
  deleteRedisSubscriptionById(id: number) {
    return this.http.delete<{ count: number }>(`${this.coreApi}/RedisSubscriptions/${id}`);
  }

  /**
   * Delete Redis subscriptions by condition
   */
  deleteRedisSubscriptionsByWhere(where: string) {
    return this.http.delete<{ count: number }>(`${this.coreApi}/RedisSubscriptions?where=${where}`);
  }

  // =====================
  // Service Management
  // =====================

  /**
   * Get all services
   */
  getServices(): Observable<IService[]> {
    return this.http.get<IService[]>(`${this.coreApi}/services`);
  }

  /**
   * Get service by ID
   */
  getService(id: number): Observable<IService> {
    return this.http.get<IService>(`${this.coreApi}/services/${id}`);
  }

  // =====================
  // Whitelist Management
  // =====================

  /**
   * Get whitelists with pagination and filtering
   */
  getWhiteLists(
    active: string,
    direction: string,
    page: number,
    size: number,
    filterValue: string,
    customConditions?: any
  ): Observable<any> {
    const filter = getFilter(
      active,
      direction,
      size,
      page,
      filterValue,
      null,
      null,
      whiteListKeys,
      null,
      null,
      null,
      customConditions
    );

    return this.http.get<WhiteList[]>(`${this.coreApi}/Whitelists?${filter !== 'filter=' ? filter + '&' : ''}`, {
      observe: 'response',
    });
  }

  /**
   * Add whitelist
   */
  addWhiteList(data): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/Whitelists`, data);
  }

  /**
   * Get total count of whitelists
   */
  getWhiteListsCount(filterValue: string, customConditions?: any): Observable<any> {
    const whereParam = getCountWhere(filterValue, null, null, whiteListKeys, null, null, customConditions);
    return this.http.get<any>(`${this.coreApi}/Whitelists/count?${'where=' + whereParam}`);
  }

  /**
   * Get whitelist by ID
   */
  getWhiteListById(id: number): Observable<any> {
    return this.http.get<WhiteList>(`${this.coreApi}/Whitelists/${id}`);
  }

  /**
   * Update whitelist by ID
   */
  updateWhiteListById(data: any): Observable<any> {
    return this.http.put<any>(`${this.coreApi}/Whitelists`, data);
  }

  /**
   * Delete whitelist by ID
   */
  deleteWhitelistById(id: number): Observable<any> {
    return this.http.delete<any>(`${this.coreApi}/Whitelists/${id}`);
  }

  // =====================
  // Tracking Source Management
  // =====================

  /**
   * Get tracking sources with pagination and filtering
   */
  getTrackingSources(
    active: string,
    direction: string,
    page: number,
    size: number,
    filterValue: string,
    customerFilter?: any
  ): Observable<any> {
    const filter = getFilter(
      active,
      direction,
      size,
      page,
      filterValue,
      null,
      null,
      trackingSourceKeys,
      null,
      customerFilter
    );
    return this.http.get<any>(
      `${this.coreApi}/TrackingSources/tracking_sources?${filter !== 'filter=' ? filter + '&' : ''}`
    );
  }

  /**
   * Get tracking sources for autocomplete
   */
  getTrackingSourcesForAutoComplete(filterValue: string, customerFilter?: any): Observable<any> {
    const filter = getFilter('', '', 10, 1, filterValue, null, null, trackingSourceKeys, null, customerFilter);
    return this.http.get<any>(
      `${this.coreApi}/TrackingSources/tracking_sources?${filter !== 'filter=' ? filter + '&' : ''}`
    );
  }

  /**
   * Get sources by filter
   */
  getSourcesByFilter(filter): Observable<GetSources[]> {
    filter = 'filter=' + encodeURIComponent(JSON.stringify(filter));
    return this.http.get<GetSources[]>(`${this.coreApi}/TrackingSources?${filter !== 'filter=' ? filter + '&' : ''}`);
  }

  /**
   * Get all tracking sources
   */
  getAllSources(): Observable<GetSources[]> {
    return this.http.get<GetSources[]>(`${this.coreApi}/TrackingSources`);
  }

  /**
   * Download all tracking numbers
   */
  downloadAllTrackingNumber(whereParam: any, customerFilter: any, sorting?: string): Observable<any> {
    let params = new HttpParams()
      .set('where', JSON.stringify(whereParam))
      .set('customerFilter', JSON.stringify(customerFilter));

    if (sorting?.length) {
      params = params.set('order', sorting);
    }

    const url = `${this.coreApi}/OpNumbers/bulk_download`;
    return this.http.get<any>(url, { params });
  }

  /**
   * Download all receiving numbers
   */
  downloadAllReceivingNumber(whereClause): Observable<any> {
    const whereParam = encodeURIComponent(JSON.stringify(whereClause));
    const url = `${this.coreApi}/ReceivingNumbers/bulk_download?where=${whereParam}`;
    return this.http.get<any>(url);
  }

  /**
   * Download all SIP gateways
   */
  downloadAllSipGates(filterValue, customerFilter): Observable<any> {
    const whereParam = getCountWhere(filterValue, null, null, trackingKeys, customerFilter);
    return this.http.get<any>(`${this.coreApi}/SipGateways/bulk_download?${'where=' + whereParam}`);
  }

  /**
   * Download all tracking sources
   */
  downloadAllTrackingSources(whereParam: any): Observable<any> {
    const params = {
      where: JSON.stringify(whereParam),
    };
    return this.http.get<any>(`${this.coreApi}/TrackingSources/bulk_download`, { params });
  }

  /**
   * Delete sources by condition
   */
  deleteSourcesByWhere(where: string): Observable<any> {
    return this.http.delete<any>(`${this.coreApi}/TrackingSources?where=${where}`);
  }

  /**
   * Get total count of tracking numbers
   */
  getCount(filterName: string, filterValue: string): Observable<number> {
    return this.http.get<number>(
      `${this.coreApi}/OpNumbers/count${filterName && filterValue ? '?where[' + filterName + '][like]=%' + filterValue + '%&' : ''}`
    );
  }

  /**
   * Get total count of tracking sources
   */
  getSourcesCount(filterValue: string, customerFilter?: any): Observable<any> {
    const whereParam = getCountWhere(filterValue, null, null, trackingSourceKeys, customerFilter);
    return this.http.get<any>(`${this.coreApi}/TrackingSources/tracking_sources/count?${'where=' + whereParam}`);
  }

  /**
   * Get number detail by ID
   */
  getDetailById(id: number): Observable<GetNumbers> {
    return this.http.get<GetNumbers>(`${this.coreApi}/OpNumbers/${id}`);
  }

  /**
   * Save number detail by ID
   */
  saveDetailById(data: GetNumbers, id: number): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/OpNumbers/${id}/UpdateTrackingSource`, { ...data });
  }

  /**
   * Update past call logs
   */
  updateLogs(id: number, tracking_number: string): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/OpNumbers/updateLogs`, { id, trackingNumber: tracking_number });
  }

  /**
   * Delete number detail by ID
   */
  deleteDetailById(id: number): Observable<any> {
    return this.http.delete<any>(`${this.coreApi}/OpNumbers/${id}`);
  }

  /**
   * Delete number by filter string
   */
  deleteOpNumbersByWhere(where: string): Observable<any> {
    return this.http.delete<any>(`${this.coreApi}/OpNumbers?where=${where}`);
  }

  /**
   * Get op numbers by filtering
   */
  getOpNumbersByFilter(filter: any): Observable<any> {
    if (filter) {
      const filterString = encodeURIComponent(JSON.stringify(filter));
      return this.http.get<any>(`${this.coreApi}/OpNumbers?filter=${filterString}`);
    }

    return this.http.get<any>(`${this.coreApi}/OpNumbers`);
  }

  /**
   * Update customer ID in the op number table
   */
  updateOpNumberCustomer(updateInfo: any): Observable<any> {
    const body = new HttpParams().set('updateInfo', JSON.stringify(updateInfo));

    return this.http.post(`${this.coreApi}/OpNumbers/updateCustomer`, body.toString(), {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
    });
  }

  /**
   * Add new tracking number
   */
  addNumber(data: GetNumbers): Observable<any> {
    return this.http.put<any>(`${this.coreApi}/OpNumbers`, data);
  }

  /**
   * Check the scheduler status for the passed number
   * if the scheduler is not found, it will be created at the moment
   * @param number
   * @returns
   */
  syncTrackingNumberSchedulerStatus(number: string): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/OpNumbers/scheduler-refresh`, { multiple: false, number: [number] });
  }

  /**
   * Same as syncTrackingNumberSchedulerStatus but for multiple numbers
   * @param numbers
   * @returns
   */
  syncTrackingNumbersSchedulerStatus(numbers: string[]): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/OpNumbers/scheduler-refresh`, { multiple: true, number: numbers });
  }

  /**
   * Delete user by ID
   */
  deleteUserById(id: number): Observable<any> {
    return this.http.delete<any>(`${this.coreApi}/DashUsers/${id}`);
  }

  /**
   * Get users by filter
   */
  getUsersByFilter(filter: string): Observable<any> {
    return this.http.get<any>(`${this.coreApi}/DashUsers?filter=${filter}`);
  }

  /**
   * Delete users by condition
   */
  deleteUsersByWhere(where: string): Observable<any> {
    return this.http.delete<any>(`${this.coreApi}/DashUsers?where=${where}`);
  }

  /**
   * Add new tracking source
   */
  addSource(data: GetSources): Observable<any> {
    return this.http.put<any>(`${this.coreApi}/TrackingSources`, data);
  }

  /**
   * Edit tracking source
   */
  saveSourceById(data: GetSources): Observable<any> {
    return this.http.put<any>(`${this.coreApi}/TrackingSources`, data);
  }

  /**
   * Get source detail by ID
   */
  getSourceDetailById(id: number): Observable<GetSources> {
    return this.http.get<GetSources>(`${this.coreApi}/TrackingSources/${id}`);
  }

  /**
   * Delete source by ID
   */
  deleteSourceById(id: number): Observable<any> {
    return this.http.delete<any>(`${this.coreApi}/TrackingSources/${id}`);
  }

  /**
   * Delete source with options
   */
  deleteSourceWithOption(payload: any): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/TrackingSources/deleteSourceWithOption`, payload);
  }

  /**
   * Update customer ID in the tracking source table
   */
  updateTrackingSourceCustomer(updateInfo: any): Observable<any> {
    const body = new HttpParams().set('updateInfo', JSON.stringify(updateInfo));

    return this.http.post(`${this.coreApi}/TrackingSources/updateCustomer`, body.toString(), {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
    });
  }

  // =====================
  // Call Logs Management
  // =====================

  /**
   * Get logs from support
   */
  getLogsFromSupport(
    active: string,
    direction: string,
    page: number,
    size: number,
    filterValue: string,
    date1: string,
    date2: string,
    option: string,
    value?: string
  ): Observable<HttpResponse<CallLogSupport[]>> {
    const filter = getFilter(active, direction, size, page, filterValue, date1, date2, callLogKeysForSupport, value);
    return this.http.get<CallLogSupport[]>(
      `${this.coreApi}/CallLogSupports?${filter !== 'filter=' ? filter + '&' : ''}`,
      { observe: 'response' }
    );
  }

  /**
   * Get logs for comparison
   */
  async getLogsForCompare(
    active: string,
    direction: string,
    page: number,
    size: number,
    filterName: string,
    filterValue: string,
    date1: string,
    date2: string,
    option: string,
    value?: string
  ) {
    const filter = getFilter(active, direction, size, page, filterValue, date1, date2, callLogKeys, value);
    return await this.http
      .get<LightLog[]>(`${this.coreApi}/LightCallLogs?${filter !== 'filter=' ? filter + '&' : ''}`, {
        observe: 'response',
      })
      .toPromise();
  }

  /**
   * Get light logs
   */
  getLightLogs(
    active: string,
    direction: string,
    page: number,
    size: number,
    filterName: string,
    filterValue: string,
    date1: string,
    date2: string,
    option: string,
    value?: string
  ): Observable<HttpResponse<LightLog[]>> {
    const filter = getFilter(active, direction, size, page, filterValue, date1, date2, callLogKeys, value);
    return this.http.get<LightLog[]>(`${this.coreApi}/LightCallLogs?${filter !== 'filter=' ? filter + '&' : ''}`, {
      observe: 'response',
    });
  }

  /**
   * Get call recording
   */
  getCallRecording(id): Observable<CallRecording> {
    return this.http.get<CallRecording>(`${this.coreApi}/Storages/getRecording?recording_id=${id}`);
  }

  /**
   * Delete call logs by filter string
   */
  deleteCallLogsByWhere(where: string): Observable<any> {
    return this.http.delete<{ count: number }>(`${this.coreApi}/CallLogs?where=${where}`);
  }

  // =====================
  // Tracking Numbers Management
  // =====================

  /**
   * Get tracking numbers with pagination and filtering
   */
  getTrackingNumbers(
    active: string,
    direction: string,
    page: number,
    size: number,
    filterValue: string,
    customFilters?: any
  ): Observable<HttpResponse<GetNumbers[]>> {
    const filter = getFilter(
      active,
      direction,
      size,
      page,
      filterValue,
      null,
      null,
      trackingKeys,
      null,
      customFilters,
      'tracking_number,ReceivingNumber.number'
    );

    return this.http.get<GetNumbers[]>(
      `${this.coreApi}/OpNumbers/tracking_numbers?${filter !== 'filter=' ? filter + '&' : ''}`,
      { observe: 'response' }
    );
  }

  /**
   * Get tracking numbers for autocomplete
   */
  getTrackingNumbersForAutoComplete(filterValue: string, customerFilter?: any): Observable<HttpResponse<GetNumbers[]>> {
    const filter = getFilter('', '', 10, 1, filterValue, null, null, ['tracking_number'], null, customerFilter);

    return this.http.get<GetNumbers[]>(
      `${this.coreApi}/OpNumbers/tracking_numbers?${filter !== 'filter=' ? filter + '&' : ''}`,
      { observe: 'response' }
    );
  }

  /**
   * Get tracking numbers with count
   */
  getTrackingNumbersWithCount(
    active: string,
    direction: string,
    page: number,
    size: number,
    filterValue: string,
    customerFilter?: any
  ): Observable<HttpResponse<GetNumbers[]>> {
    const filter = getFilter(
      active,
      direction,
      size,
      page,
      filterValue,
      null,
      null,
      trackingKeys,
      null,
      customerFilter
    );

    return this.http.get<GetNumbers[]>(
      `${this.coreApi}/OpNumbers/tracking_numbers_count?${filter !== 'filter=' ? filter + '&' : ''}`,
      { observe: 'response' }
    );
  }

  /**
   * Get tracking numbers for dropdown
   */
  getTrackingNumbersDropdown(customerFilter?: any): Observable<GetNumbers[]> {
    customerFilter = encodeURIComponent(JSON.stringify(customerFilter));
    return this.http.get<GetNumbers[]>(`${this.coreApi}/OpNumbers/tracking_numbers_count?filter=${customerFilter}`);
  }

  /**
   * Get total count of tracking numbers
   */
  getTrackingNumberCount(filterValue: string, customFilter?: any): Observable<any> {
    const whereParam = getCountWhere(
      filterValue,
      null,
      null,
      trackingKeys,
      customFilter,
      'tracking_number,ReceivingNumber.number'
    );
    return this.http.get<any>(`${this.coreApi}/OpNumbers/tracking_numbers/count?${'where=' + whereParam}`);
  }

  // =====================
  // User List Management
  // =====================

  /**
   * Get users list with pagination and filtering
   */
  getUsersList(
    active: string,
    direction: string,
    page: number,
    size: number,
    filterName: string,
    filterValue: string,
    customerFilter
  ): Observable<IUser[]> {
    const filter = getFilter(active, direction, size, page, filterValue, null, null, userKeys, null, customerFilter);
    const url = `${this.coreApi}/DashUsers?${filter !== 'filter=' ? filter + '&' : ''}`;
    return this.http.get<IUser[]>(url);
  }

  /**
   * Get all user list
   */
  getAllUserList(): Observable<IUser[]> {
    const url = `${this.coreApi}/DashUsers`;
    return this.http.get<IUser[]>(url);
  }

  // =====================
  // Role Management
  // =====================

  /**
   * Get roles list with pagination and filtering
   */
  getRolesList(
    active: string,
    direction: string,
    page: number,
    size: number,
    filterValue: string,
    customFilter?: any
  ): Observable<IRole[]> {
    const filter = getFilter(active, direction, size, page, filterValue, null, null, roleKeys, null, customFilter);
    const url = `${this.coreApi}/DashRoles?${filter !== 'filter=' ? filter + '&' : ''}`;
    return this.http.get<IRole[]>(url);
  }

  /**
   * Get role by ID
   */
  getRole(id: number): Observable<IRole> {
    const url = `${this.coreApi}/DashRoles/${id}`;
    return this.http.get<IRole>(url);
  }

  /**
   * Update role
   */
  updateRole(data: IRole): Observable<IRole> {
    return this.http.patch<IRole>(`${this.coreApi}/DashRoles/${data.id}`, data);
  }

  /**
   * Create new role
   */
  createRole(data): Observable<IRole> {
    return this.http.post<IRole>(`${this.coreApi}/DashRoles`, data);
  }

  /**
   * Get assigned users
   */
  getAssingedUsers(id: number): Observable<IUser[]> {
    return this.http.post<IUser[]>(`${this.coreApi}/DashRoles/AssociatedDashUsers`, { id });
  }

  /**
   * Delete role by ID
   */
  deleteRoleById(id: number): Observable<any> {
    return this.http.delete<any>(`${this.coreApi}/DashRoles/${id}`);
  }

  /**
   * Delete roles by condition
   */
  deleteRolesByWhere(where: string): Observable<any> {
    return this.http.delete<any>(`${this.coreApi}/DashRoles?where=${where}`);
  }

  /**
   * Delete all visibility by role ID
   */
  deleteAllVisibilityByRoleId(id: number): Observable<any> {
    return this.http.delete<any>(`${this.coreApi}/DashRoles/${id}/GuiVisibilities`);
  }

  /**
   * Create role principal
   */
  createRolePrincipal(data: any): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/DashRoles/${data.roleId}/principals`, { data });
  }

  // =====================
  // Role Mapping Management
  // =====================

  /**
   * Get role mapping by filter
   */
  getRoleMappingByFilter(filter: string): Observable<any> {
    return this.http.get<any>(`${this.coreApi}/DashRoleMappings?filter=${filter}`);
  }

  /**
   * Update role mapping
   */
  updateRoleMapping(data: any): Observable<any> {
    return this.http.patch<any>(`${this.coreApi}/DashRoleMappings/${data.id}`, data);
  }

  /**
   * Create role mapping
   */
  createRoleMapping(data: any): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/DashRoleMappings`, data);
  }

  /**
   * Delete role mapping by condition
   */
  deleteRoleMappingByWhere(where: string) {
    return this.http.delete<{ count: number }>(`${this.coreApi}/DashRoleMappings?where=${where}`);
  }

  /**
   * Delete role mapping by ID
   */
  deleteRoleMappingById(id: number) {
    return this.http.delete<{ count: number }>(`${this.coreApi}/DashRoleMappings/${id}`);
  }

  /**
   * Delete all user role mapping
   */
  deleteAllUserRoleMapping(id: number) {
    return this.http.delete<{ count: number }>(`${this.coreApi}/DashUsers/${id}/DashRoleMapping`);
  }

  // =====================
  // GUI Visibility Management
  // =====================

  /**
   * Get GUI visibilities by filter
   */
  getGuiVisibilitiesByFilter(filter: string): Observable<GuiVisibility[]> {
    return this.http.get<GuiVisibility[]>(`${this.coreApi}/GuiVisibilities?filter=${filter}`);
  }

  /**
   * Update GUI visibility
   */
  updateGuiVisibility(data: any): Observable<any> {
    return this.http.put<any>(`${this.coreApi}/GuiVisibilities`, { ...data });
  }

  /**
   * Create GUI visibility
   */
  createGuiVisibility(data: any): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/GuiVisibilities`, { ...data });
  }

  /**
   * Delete GUI visibility by condition
   */
  deleteGuiVisibilityByWhere(where: string): Observable<any> {
    return this.http.delete<any>(`${this.coreApi}/GuiVisibilities?where=${where}`);
  }

  // =====================
  // GUI Section Management
  // =====================

  /**
   * Get all GUI sections
   */
  getGuiSections(): Observable<GuiSection[]> {
    return this.http.get<GuiSection[]>(`${this.coreApi}/GuiSections`);
  }

  // =====================
  // GUI Permission Management
  // =====================

  /**
   * Get all GUI permissions
   */
  getGuiPermission(): Observable<GuiPermission[]> {
    return this.http.get<GuiPermission[]>(`${this.coreApi}/GuiPermissions`);
  }

  // =====================
  // Call Log Management
  // =====================

  /**
   * Get call log by ID
   */
  getLogById(id: number): Observable<CallLog> {
    return this.http.get<CallLog>(`${this.coreApi}/CallLogs/${id}`);
  }

  /**
   * Save log by ID
   */
  saveLogById(data: CallLog): Observable<any> {
    return this.http.put<any>(`${this.coreApi}/CallLogs`, data);
  }

  /**
   * Update customer ID in the call log table
   */
  updateCallLogCustomer(updateInfo: any): Observable<any> {
    const body = new HttpParams().set('updateInfo', JSON.stringify(updateInfo));

    return this.http.post(`${this.coreApi}/CallLogs/updateCustomer`, body.toString(), {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
    });
  }

  /**
   * Update phonebook
   */
  updatePhonebook(caller_contactId: number, id: number): Observable<any> {
    return this.http.put<any>(`${this.coreApi}/CallLogs/update_phonebook`, {
      id: id,
      caller_contactId: caller_contactId,
    });
  }

  /**
   * Get call logs counters for dashboard
   */
  getDashLogsCount(offset, weekend): Observable<LogsCount> {
    const param = 'offset=' + offset + '&weekend=' + weekend;
    return this.http.get<LogsCount>(`${this.coreApi}/CallLogs/count_logs?${param}`);
  }

  /**
   * Get dashboard statistics
   */
  getDashStatistics(startDate: string, endDate: string): Observable<any> {
    const param = 'startDate=' + startDate + '&endDate=' + endDate;
    return this.http.get<any>(`${this.coreApi}/Reports/statistics?${param}`);
  }

  /**
   * Get dashboard data for specified widget
   * @param widgetName Name of the dashboard widget to fetch data for
   * @param startDate Optional start date
   * @param endDate Optional end date
   * @param timezoneOffset Timezone offset string
   * @param weekStart Day of week to start (0 for Sunday, 1 for Monday)
   * @param customerId Optional customer ID filter
   * @param options Request options
   * @returns Observable with the dashboard widget data
   */
  dashboardData(
    widgetName: string,
    startDate?: string | null,
    endDate?: string | null,
    timezoneOffset?: string | null,
    weekStart?: number | null,
    customerId?: number | null,
    trackingSources?: number[] | null
  ): Observable<any> {
    let body = new HttpParams();

    // Add all parameters
    if (widgetName) body = body.set('widgetName', widgetName);
    if (startDate) body = body.set('startDate', startDate);
    if (endDate) body = body.set('endDate', endDate);
    if (timezoneOffset) body = body.set('timezoneOffset', timezoneOffset);
    if (weekStart !== undefined && weekStart !== null) body = body.set('weekStart', weekStart.toString());
    if (customerId) body = body.set('customerId', customerId.toString());

    // Add tracking sources parameter as JSON string if provided
    if (trackingSources && trackingSources.length > 0) {
      body = body.set('trackingSources', JSON.stringify(trackingSources));
    }

    // Post the payload to the service
    return this.http.post(`${this.coreApi}/Reports/dashboardData`, body.toString(), {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
    });
  }

  /**
   * Get phonebook by ID
   */
  getPhoneBookById(id: number): Observable<PhoneBook> {
    return this.http.get<PhoneBook>(`${this.coreApi}/PhoneBooks/${id}`);
  }

  /**
   * Get all phonebooks
   */
  getAllPhonebooks(filter): Observable<PhoneBook[]> {
    filter = encodeURIComponent(JSON.stringify(filter));
    return this.http.get<PhoneBook[]>(`${this.coreApi}/PhoneBooks?filter=${filter}`);
  }

  /**
   * Add phonebook
   */
  addPhoneBook(data: PhoneBook): Observable<any> {
    return this.http.put<any>(`${this.coreApi}/Phonebooks`, data);
  }

  // =====================
  // Receiving Number Management
  // =====================

  /**
   * Get receiving numbers with pagination and filtering
   */
  getReceivingNumbers(
    active: string,
    direction: string,
    page: number,
    size: number,
    filterValue: string,
    customerFilter?: any
  ): Observable<HttpResponse<ReceivingNumber[]>> {
    const filter = getFilter(
      active,
      direction,
      size,
      page,
      filterValue,
      null,
      null,
      receivingNumberKeys,
      null,
      customerFilter,
      'number,OpNumber.tracking_number'
    );
    return this.http.get<ReceivingNumber[]>(
      `${this.coreApi}/ReceivingNumbers/receiving_numbers?${filter !== 'filter=' ? filter + '&' : ''}`,
      { observe: 'response' }
    );
  }

  /**
   * Get receiving numbers for dropdown
   */
  getReceivingNumbersDropdown(customerFilter?: any): Observable<ReceivingNumber[]> {
    if (customerFilter?.length) {
      customerFilter = encodeURIComponent(JSON.stringify(customerFilter));
      return this.http.get<ReceivingNumber[]>(`${this.coreApi}/ReceivingNumbers?filter=${customerFilter}`);
    }

    return this.http.get<ReceivingNumber[]>(`${this.coreApi}/ReceivingNumbers`);
  }

  /**
   * Get total count of receiving numbers
   */
  getReceivingNumbersCount(filterValue: string, customerFilter?: any): Observable<any> {
    const whereParam = getCountWhere(
      filterValue,
      null,
      null,
      receivingNumberKeys,
      customerFilter,
      'number,OpNumber.tracking_number'
    );
    return this.http.get<any>(`${this.coreApi}/ReceivingNumbers/count?${'where=' + whereParam}`);
  }

  /**
   * Get all receiving numbers
   */
  getAllReceivingNumbers(): Observable<HttpResponse<ReceivingNumber[]>> {
    return this.http.get<ReceivingNumber[]>(`${this.coreApi}/ReceivingNumbers`, { observe: 'response' });
  }

  /**
   * Add receiving number
   */
  addReceivingNumber(data): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/ReceivingNumbers`, data);
  }

  /**
   * Get receiving number by ID
   */
  getReceivingNumberById(id: number): Observable<ReceivingNumber> {
    return this.http.get<ReceivingNumber>(`${this.coreApi}/ReceivingNumbers/${id}`);
  }

  /**
   * Update receiving number by ID
   */
  updateReceivingNumberById(data: ReceivingNumber): Observable<any> {
    return this.http.patch<any>(`${this.coreApi}/ReceivingNumbers`, data);
  }

  /**
   * Delete receiving number by ID
   */
  deleteReceivingNumberById(id: number): Observable<any> {
    return this.http.delete(`${this.coreApi}/ReceivingNumbers/${id}`);
  }

  /**
   * Get tracking numbers by receiving number
   */
  getTrackingNumbersByReceivingNumber(id: number): Observable<GetNumbers[]> {
    const condition = {
      where: {
        receiving_numberId: id,
      },
    };
    const filter = encodeURIComponent(JSON.stringify(condition));
    return this.http.get<GetNumbers[]>(`${this.coreApi}/OpNumbers?filter=${filter}`);
  }

  // =====================
  // Routing Action Management
  // =====================

  /**
   * Get routing actions with pagination and filtering
   */
  getRoutingActions(
    active: string,
    direction: string,
    page: number,
    size: number,
    filterValue: string
  ): Observable<HttpResponse<RoutingAction[]>> {
    const filter = getFilter(active, direction, size, page, filterValue, null, null, sipGatewayKeys);
    return this.http.get<RoutingAction[]>(
      `${this.coreApi}/RoutingActions?${filter !== 'filter=' ? filter + '&' : ''}`,
      { observe: 'response' }
    );
  }

  /**
   * Get all routing actions
   */
  getAllRoutingActions(): Observable<RoutingAction[]> {
    return this.http.get<RoutingAction[]>(`${this.coreApi}/RoutingActions`);
  }

  /**
   * Add routing action
   */
  addRoutingAction(data): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/RoutingActions`, data);
  }

  /**
   * Get routing action by ID
   */
  getRoutingActionById(id: number): Observable<RoutingAction> {
    return this.http.get<RoutingAction>(`${this.coreApi}/RoutingActions/${id}`);
  }

  /**
   * Update routing action by ID
   */
  updateRoutingActionById(data: RoutingAction): Observable<any> {
    return this.http.put<any>(`${this.coreApi}/RoutingActions`, data);
  }

  /**
   * Delete routing action
   */
  deleteRoutingActionById(id: number): Observable<any> {
    return this.http.delete(`${this.coreApi}/RoutingActions/${id}`);
  }

  /**
   * Get tracking numbers that use SIP gateway
   */
  getTrackingNumbersBySipGateway(id: number): Observable<GetNumbers[]> {
    const condition = {
      where: {
        sip_gatewayId: id,
      },
    };
    const filter = encodeURIComponent(JSON.stringify(condition));
    return this.http.get<GetNumbers[]>(`${this.coreApi}/OpNumbers?filter=${filter}`);
  }

  /**
   * Get tracking numbers that use tracking source
   */
  getTrackingNumbersByTrackingSource(id: number): Observable<GetNumbers[]> {
    const condition = {
      where: {
        tracking_sourceId: id,
      },
    };
    const filter = encodeURIComponent(JSON.stringify(condition));
    return this.http.get<GetNumbers[]>(`${this.coreApi}/OpNumbers?filter=${filter}`);
  }

  // =====================
  // SIP Gateway Management
  // =====================

  getSipGatewayGroups(enabledOnly = true): Observable<any[]> {
    const filter = encodeURIComponent(
      JSON.stringify({
        ...(enabledOnly ? { where: { enabled: true } } : {}),
        order: ['direction ASC', 'name ASC'],
      })
    );
    return this.http.get<any[]>(`${this.coreApi}/SipGatewayGroups?filter=${filter}`);
  }

  /**
   * Get SIP gateways with pagination and filtering
   */
  getSipGateways(
    active: string,
    direction: string,
    page: number,
    size: number,
    filterValue: string,
    customerFilter?: any,
    customConditions?: any
  ): Observable<HttpResponse<SipGateways[]>> {
    const filter = getFilter(
      active,
      direction,
      size,
      page,
      filterValue,
      null,
      null,
      sipGatewayKeys,
      null,
      customerFilter,
      null,
      customConditions
    );

    return this.http.get<SipGateways[]>(`${this.coreApi}/SipGateways?${filter !== 'filter=' ? filter + '&' : ''}`, {
      observe: 'response',
    });
  }

  /**
   * Get total count of SIP gateways
   */
  getSipGatewayCount(filterValue: string, customerFilter?: any, customConditions?: any): Observable<any> {
    const whereParam = getCountWhere(filterValue, null, null, sipGatewayKeys, customerFilter, null, customConditions);
    return this.http.get<any>(`${this.coreApi}/SipGateways/count?${'where=' + whereParam}`);
  }

  /**
   * Get queues with pagination and filtering
   */
  getQueues(
    active: string,
    direction: string,
    page: number,
    size: number,
    filterValue: string,
    customerFilter?: any,
    customConditions?: any
  ): Observable<HttpResponse<any[]>> {
    const filter = getFilter(
      active,
      direction,
      size,
      page,
      filterValue,
      null,
      null,
      ['name', 'description', 'strategy'],
      null,
      customerFilter,
      null,
      customConditions
    );

    return this.http.get<any[]>(`${this.coreApi}/Queues?${filter !== 'filter=' ? filter + '&' : ''}`, {
      observe: 'response',
    });
  }

  /**
   * Get total count of queues
   */
  getQueuesCount(filterValue: string, customerFilter?: any, customConditions?: any): Observable<any> {
    const whereParam = getCountWhere(
      filterValue,
      null,
      null,
      ['name', 'description', 'strategy'],
      customerFilter,
      null,
      customConditions
    );
    return this.http.get<any>(`${this.coreApi}/Queues/count?${'where=' + whereParam}`);
  }

  /**
   * Get agents
   */
  getAgents(customerFilter?: any): Observable<any[]> {
    const filter = customerFilter ? encodeURIComponent(JSON.stringify({ where: customerFilter })) : '';
    return this.http.get<any[]>(`${this.coreApi}/Agents?${filter ? 'filter=' + filter : ''}`);
  }

  /**
   * Get only outbound SIP gateways
   */
  getOutboundSipGateways(filter: any): Observable<SipGateways[]> {
    filter = encodeURIComponent(JSON.stringify(filter));
    return this.http.get<SipGateways[]>(`${this.coreApi}/SipGateways?filter=${filter}`);
  }

  /**
   * Get all SIP gateways
   */
  getAllSipGateways(customerFilter, customConditions): Observable<SipGateways[]> {
    const filter = getFilter(
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      customerFilter,
      null,
      customConditions
    );
    return this.http.get<SipGateways[]>(`${this.coreApi}/SipGateways?${filter !== 'filter=' ? filter + '&' : ''}`);
  }

  /**
   * Add SIP gateway
   */
  addSipGateway(data): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/SipGateways`, data);
  }

  /**
   * Get SIP gateway by ID
   */
  getSipGatewayById(id: number): Observable<SipGateways> {
    return this.http.get<SipGateways>(`${this.coreApi}/SipGateways/${id}`);
  }

  /**
   * Update SIP gateway by ID
   */
  updateSipGatewayById(data: SipGateways): Observable<any> {
    return this.http.patch<any>(this.coreApi + '/SipGateways/' + data.id, data);
  }

  /**
   * Delete SIP gateway by ID
   */
  deleteSipGatewayById(id: number): Observable<any> {
    return this.http.delete(`${this.coreApi}/SipGateways/${id}`);
  }

  /**
   * Delete SIP gateway with options
   */
  deleteSipGatewayWithOption(payload: any): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/SipGateways/deleteSipGatewayWithOption`, payload);
  }

  /**
   * Assign SIP gateway order
   */
  assignSipGatewayOrder(data): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/SipGateways/order`, { gw_list: data });
  }

  /**
   * Mark default outbound gateway
   */
  markDefaultOutboundGateway(id: number): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/SipGateways/set_default`, { gateway_id: id });
  }

  // =====================
  // Bulk Upload
  // =====================

  /**
   * Bulk upload receiving numbers
   */
  bulkUpload(data): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/ReceivingNumbers/bulk_upload`, data);
  }

  /**
   * Bulk upload tracking numbers
   */
  bulkTNumbersUpload(data): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/OpNumbers/bulk_upload`, data);
  }

  /**
   * Bulk upload SIP gateways
   */
  bulkSipGatewaysUpload(data): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/SipGateways/bulk_upload`, data);
  }

  /**
   * Bulk upload tracking sources
   */
  bulkTrackingSourcesUpload(data): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/TrackingSources/bulk_upload`, data);
  }

  // =====================
  // Reports
  // =====================

  /**
   * Activity report
   */
  activityReport(startDate, endDate, offset, customerId): Observable<any> {
    let body = new HttpParams().set('start_date', startDate).set('end_date', endDate).set('offset', offset);

    if (customerId) {
      body = new HttpParams()
        .set('start_date', startDate)
        .set('end_date', endDate)
        .set('offset', offset)
        .set('customerId', customerId);
    }

    return this.http.post(`${this.coreApi}/Reports/activity_report`, body.toString(), {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
    });
  }

  /**
   * Activity report
   */
  exportActivityReport(filters): Observable<any> {
    const body = new HttpParams().set('filters', JSON.stringify(filters));
    return this.http.post(`${this.coreApi}/Reports/export_activity_report`, body.toString(), {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
    });
  }

  /**
   * Overview report
   */
  overviewReport(startDate, endDate, offset, customerId): Observable<any> {
    let body = new HttpParams().set('start_date', startDate).set('end_date', endDate).set('offset', offset);

    if (customerId) {
      body = new HttpParams()
        .set('start_date', startDate)
        .set('end_date', endDate)
        .set('offset', offset)
        .set('customerId', customerId);
    }

    return this.http.post(`${this.coreApi}/Reports/overview_report`, body.toString(), {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
    });
  }

  /**
   * Get all report templates
   */
  getReportTemplates(filters): Observable<any[]> {
    return this.http.get<any[]>(`${this.coreApi}/Templates?filter=${JSON.stringify(filters)}`);
  }

  /**
   * Add new report template
   */
  addTemplate(payload): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/Templates`, payload);
  }

  /**
   * Share report template
   */
  shareTemplate(payload): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/Templates/shareTemplate`, payload);
  }

  /**
   * Update a report template
   */
  updateTemplateById(id: number, payload): Observable<any> {
    return this.http.put<any>(`${this.coreApi}/Templates/${id}`, payload);
  }

  /**
   * Delete a report template
   */
  deleteTemplateById(id: number): Observable<any> {
    return this.http.delete(`${this.coreApi}/Templates/${id}`);
  }

  /**
   * Get logs count from backend
   */
  getLogsCount(
    filterValue: string,
    date1: string | Date,
    date2: string | Date,
    customerFilter: any,
    customCondition?: any
  ): Observable<any> {
    const whereParam = getCountWhere(
      filterValue,
      date1,
      date2,
      callLogKeys,
      customerFilter,
      'OpNumber.ReceivingNumber.number,trackingNumber,trackingNumber',
      customCondition
    );
    return this.http.get<any>(`${this.coreApi}/CallLogs/count?${'where=' + whereParam}`);
  }

  /**
   * Get call logs with pagination and filtering
   */
  getLogs(
    active: string,
    direction: string,
    page: number,
    size: number,
    filterValue: string,
    date1: any,
    date2: any,
    customFilter?: any,
    customCondition?: any
  ): Observable<HttpResponse<CallLog[]>> {
    const filter = getFilter(
      active,
      direction,
      size,
      page,
      filterValue,
      date1,
      date2,
      callLogKeys,
      null,
      customFilter,
      'OpNumber.ReceivingNumber.number,trackingNumber,trackingNumber',
      customCondition
    );
    // Use the LightCallLogs endpoint: same shape as CallLogs but its OpNumber
    // relation resolves to LightOpNumber, which omits the Ivr include (and its
    // root_audio / root_na_audio blobs) that was bloating the list response.
    return this.http.get<CallLog[]>(`${this.coreApi}/LightCallLogs?${filter !== 'filter=' ? filter + '&' : ''}`, {
      observe: 'response',
    });
  }

  /**
   * Get call log export
   */
  /*
  getCallLogExport(filters): Observable<any> {
    let body = new HttpParams().set('filters', JSON.stringify(filters))
    return this.http.post(`${this.coreApi}/Reports/export_report`, body.toString(), {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
    });
  }
  */
  getCallLogExport(startDate, endDate, offset, customerId): Observable<any> {
    let body = new HttpParams().set('start_date', startDate).set('end_date', endDate).set('offset', offset);

    if (customerId) {
      body = new HttpParams()
        .set('start_date', startDate)
        .set('end_date', endDate)
        .set('offset', offset)
        .set('customerId', customerId);
    }

    return this.http.post(`${this.coreApi}/Reports/export_report`, body.toString(), {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
    });
  }

  /**
   * Compare date range
   */
  compareDatarange(daterange1, daterange2): Observable<any> {
    const body = new HttpParams()
      .set('start_daterange', daterange1)
      .set('end_daterange', daterange2)
      .set('daterange', 'true')
      .set('view_by', '2');

    return this.http.post(`${this.coreApi}/CallLogs/compare_report`, body.toString(), {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
    });
  }

  /**
   * Compare date range for call log
   */
  compareDatarange_calllog(daterange1, daterange2): Observable<any> {
    return this.http.get(
      `${this.coreApi}/CallLogs/compare_report?start_daterange=${daterange1}&end_daterange=${daterange2}&daterange=true&view_by=2`
    );
  }

  // =====================
  // Product Management
  // =====================

  /**
   * Get products list
   */
  getProducts(filter): Observable<any> {
    return this.http.get(`${this.coreApi}/Products?filter=` + encodeURIComponent(JSON.stringify(filter)), filter);
  }

  /**
   * Get product by ID
   */
  getPlanConfiguration(id: number): Observable<any> {
    return this.http.get(`${this.coreApi}/Products/${id}/plan-configuration`);
  }
  savePlanConfiguration(id: number, configuration: any): Observable<any> {
    return this.http.put(`${this.coreApi}/Products/${id}/plan-configuration`, configuration);
  }
  getProductById(id: number): Observable<any> {
    return this.http.get<any>(`${this.coreApi}/Products/${id}`);
  }

  /**
   * Get product variation list
   */
  getProductVariations(filter): Observable<any> {
    return this.http.get(`${this.coreApi}/ProductVariations?filter=` + JSON.stringify(filter), filter);
  }

  /**
   * Get product variation by ID
   */
  getProductVariationById(id): Observable<any> {
    return this.http.get(`${this.coreApi}/ProductVariations/${id}`);
  }

  /**
   * Add product variation
   */
  addProductVariation(payload): Observable<any> {
    return this.http.post(`${this.coreApi}/ProductVariations`, payload);
  }

  /**
   * Update product variation
   */
  updateProductVariation(payload, id): Observable<any> {
    return this.http.patch(`${this.coreApi}/ProductVariations/${id}`, payload);
  }

  /**
   * Delete product variation by ID
   */
  deleteProductVariationById(id): Observable<any> {
    return this.http.delete(`${this.coreApi}/ProductVariations/${id}`);
  }

  /**
   * Get products by customer ID
   */
  getProductsByCustomerId(id): Observable<any> {
    return this.http.get(`${this.coreApi}/Customers/${id}/Subscriptions`);
  }

  // =====================
  // API Key Management
  // =====================

  /**
   * Get user X-API keys
   */
  getUserXApiKeys(
    active: string,
    direction: string,
    page: number,
    size: number,
    filterValue: string,
    customerFilter: any
  ): Observable<any[]> {
    const filter = getFilter(active, direction, size, page, filterValue, null, null, apiKeys, null, customerFilter);

    const url = `${this.coreApi}/ApiKeys?${filter !== 'filter=' ? filter + '&' : ''}`;
    return this.http.get<any[]>(url);
  }

  /**
   * Get total count of user X-API keys
   */
  getXApiKeysCount(filterValue: string, whereFilter?: any): Observable<any> {
    const whereParam = getCountWhere(filterValue, null, null, apiKeys, whereFilter);
    return this.http.get<any>(`${this.coreApi}/ApiKeys/count?${'where=' + whereParam}`);
  }

  /**
   * Add user X-API key
   */
  addUserXApiKey(apiKey): Observable<ITicket> {
    return this.http.post<ITicket>(`${this.coreApi}/ApiKeys`, apiKey);
  }

  /**
   * Get user X-API key by ID
   */
  getUserXApiKeyById(id: number) {
    return this.http.get(`${this.coreApi}/ApiKeys/${id}`);
  }

  /**
   * Update user X-API key
   */
  updateUserXApiKey(id: string, data: any) {
    return this.http.put(`${this.coreApi}/ApiKeys/${id}`, data);
  }

  /**
   * Delete API key by ID
   */
  deleteApiKeyById(id: number) {
    return this.http.delete(`${this.coreApi}/ApiKeys/${id}`);
  }

  /**
   * Get currency conversion rates
   */
  getCurrencyConversionRates() {
    return this.http.get<any>(`${this.coreApi}/CurrencyRates/getCurrencyConversionRates`).pipe(
      tap(currentRates => {
        if (currentRates) {
          this.store.setCurrencyRates(currentRates);
        }
      }),
      catchError(error => {
        if (error?.status === 404 && error.error?.error?.message === 'No currency rates available') {
          return of(this.store.getCurrencyRates()?.currencyRates || null);
        }
        return throwError(() => error);
      })
    );
  }

  // =====================
  // Product Registration
  // =====================

  /**
   * Get products list for registration
   */
  getProductsReg(params = {}): Observable<any> {
    const currencyparams = encodeURIComponent(JSON.stringify(params));
    return this.http.get(`${this.coreApi}/Products/reg_list?queryParams=${currencyparams}`);
  }

  /**
   * Update product
   */
  createProduct(productData): Observable<any> {
    const payload = { ...productData };
    delete payload.id;
    return this.http.post(`${this.coreApi}/Products`, payload);
  }

  updateProduct(productData): Observable<any> {
    return this.http.put(`${this.coreApi}/Products/updateProduct`, productData);
  }

  /**
   * Create or update variation
   */
  postVariation(variationData): Observable<any> {
    if (variationData.id) return this.http.put(`${this.coreApi}/ProductVariations`, variationData);
    else {
      delete variationData.id;
      return this.http.post(`${this.coreApi}/ProductVariations`, variationData);
    }
  }

  /**
   * Subscribe or unsubscribe product
   */
  subscribeProductUpdate(isSub, subscribeData): Observable<any> {
    if (isSub) return this.http.post(`${this.coreApi}/Products/subscribe_product`, subscribeData);
    else {
      delete subscribeData.quantity;
      return this.http.post(`${this.coreApi}/Products/unsubscribe_product`, subscribeData);
    }
  }

  // =====================
  // Payment Methods
  // =====================

  /**
   * Request Intent Object
   */
  getPaymentIntent(amount, customer): Observable<any> {
    const payload = customer ? { amount: amount, customer: customer } : { amount: amount };
    return this.http.post(`${this.coreApi}/PaymentMethods/create_intent`, payload);
  }

  /**
   * Update the Customer Wallet after a successful intent
   */
  intentToWallet(intentId): Observable<any> {
    return this.http.post(`${this.coreApi}/PaymentMethods/intent_to_wallet`, { intentId: intentId });
  }

  /**
   * Get payment methods list
   */
  getPaymentMethods(id): Observable<any> {
    return this.http.get(`${this.coreApi}/PaymentMethods?filter={"where":{"customerId":${id}}}`, {});
  }

  /**
   * Add payment method
   */
  postPaymentMethods(paymentMethodsData): Observable<any> {
    return this.http.post(`${this.coreApi}/PaymentMethods/attach`, paymentMethodsData);
  }

  /**
   * Delete payment method
   */
  deletePaymentMethods(_token): Observable<any> {
    return this.http.post(`${this.coreApi}/PaymentMethods/detach`, { token: _token });
  }

  /**
   * Delete card
   */
  delete_card(payload): Observable<any> {
    return this.http.post(`${this.coreApi}/PaymentMethods/detach`, payload);
  }

  /**
   * Set payment method as primary
   */
  setPrimaryPaymentMethod(id): Observable<any> {
    return this.http.post(`${this.coreApi}/PaymentMethods/set_primary`, { payment_id: id });
  }

  // =====================
  // Payment Transactions
  // =====================

  /**
   * Get account logs count
   */
  getPaymentHistoryCount(paymentFilters: PaymentFilters): Observable<any> {
    const { query, dateRange, customerId } = paymentFilters;
    const columnsToSearch = ['description', 'cardType', 'transactionType', 'amount', 'category'];
    const where: any = {
      or: [{ productId: { eq: TNX_PRODUCT_MAP.charge } }, { productId: { eq: TNX_PRODUCT_MAP.autocharge } }],
      and: [],
    };
    if (customerId && Number(customerId) > 1) {
      where.and.push({ customerId });
    }
    if (query?.length) {
      const or = [];
      columnsToSearch.forEach(column => {
        if (column === 'amount' && !Number.isNaN(query)) {
          or.push({ amount: parseFloat(query) });
          return;
        }
        or.push({ [column]: { like: `%${query}%` } });
      });
      where.and.push({ or });
    }
    if (dateRange?.length) {
      const and = [
        {
          transactionDate: {
            between: dateRange,
          },
        },
      ];
      where.and.push({ and });
    }
    return this.http.get(
      `${this.coreApi}/PaymentTransactions/count?where=${encodeURIComponent(JSON.stringify(where))}`,
      {}
    );
  }

  getPaymentHistory(paymentFilters: PaymentFilters): Observable<any> {
    const { sortColumn, sortDirection, pageSize, pageIndex, query, dateRange, customerId, paymentId } = paymentFilters;
    const columnsToSearch = ['description', 'cardType', 'transactionType', 'amount', 'category'];
    const filter: PaymentQueryI = {
      order: [`${sortColumn} ${sortDirection}`],
      where: {
        or: [{ productId: { eq: TNX_PRODUCT_MAP.charge } }, { productId: { eq: TNX_PRODUCT_MAP.autocharge } }],
        and: [],
      },
      limit: pageSize,
      skip: (pageIndex - 1) * pageSize,
    };

    if (customerId && Number(customerId) > 1) {
      filter.where.and.push({ customerId });
    }

    if (paymentId) {
      filter.where['id'] = paymentId;
    }

    if (query?.length) {
      const or = [];
      columnsToSearch.forEach(column => {
        if (column === 'amount' && !Number.isNaN(query)) {
          or.push({ amount: parseFloat(query) });
          return;
        }
        or.push({ [column]: { like: `%${query}%` } });
      });
      filter.where.and.push({ or });
    }

    if (dateRange?.length) {
      const and = [
        {
          transactionDate: {
            between: dateRange,
          },
        },
      ];
      filter.where.and.push({ and });
    }

    return this.http.get(
      `${this.coreApi}/PaymentTransactions?filter=${encodeURIComponent(JSON.stringify(filter))}`,
      {}
    );
  }

  getNumberProviders(): Observable<any> {
    return this.http.get(`${this.coreApi}/NumberProviders`);
  }

  updateCustomerNumberProviders(customerId, providers) {
    return this.http.post<any>(`${this.coreApi}/CustomerProviderRels/updateCustomerProviders/${customerId}`, providers);
  }

  getCallChargeLogs(id, dateRange: any): Observable<any> {
    const filter: any = {
      order: ['transactionDate DESC'],
      where: { and: [] },
    };

    const or = [];
    or.push({ productId: { eq: 6 } });
    filter.where.and.push({ or });

    if (id) {
      filter.where.and.push({ customerId: id });
    }

    if (dateRange?.length) {
      const and = [
        {
          transactionDate: {
            between: dateRange,
          },
        },
      ];
      filter.where.and.push({ and });
    }

    return this.http.get(
      `${this.coreApi}/PaymentTransactions?filter=${encodeURIComponent(JSON.stringify(filter))}`,
      {}
    );
  }

  exportCallChargeLogs(filters): Observable<any> {
    const body = new HttpParams().set('filters', JSON.stringify(filters));
    return this.http.post(`${this.coreApi}/Reports/export_charge_logs`, body.toString(), {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
    });
  }

  exportTransactionHistory(filters): Observable<Blob> {
    const body = new HttpParams().set('filters', JSON.stringify(filters));
    // If you want to send the export to the user email
    // const endpoint = `${this.coreApi}/Reports/export_transaction_logs`;
    // If you want to just download it
    const endpoint = `${this.coreApi}/Reports/download_transaction_logs`;
    return this.http.post(endpoint, body.toString(), {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
      responseType: 'blob',
    });
  }

  exportPaymentHistory(filters): Observable<any> {
    const body = new HttpParams().set('filters', JSON.stringify(filters));
    return this.http.post(`${this.coreApi}/Reports/export_payment_history`, body.toString(), {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
    });
  }

  getTransactionHistoryCount(id, dateRange: any, selectedTypes, value?: string) {
    const where: any = {
      and: [],
    };

    const or = selectedTypes.map(type => {
      if (type == TNX_PRODUCT_MAP.autocharge) {
        return { and: [{ productId: { eq: type } }, { description: { eq: 'Auto-Charging' } }] };
      } else {
        return { productId: { eq: type } };
      }
    });
    where.and.push({ or });

    if (id && id > 1) {
      where.and.push({ customerId: id });
    }

    if (value && value != '') {
      or.push({ description: { like: `%${value}%` } });
      // @ts-ignore
      if (!isNaN(value)) {
        or.push({ amount: { like: `%${parseFloat(value)}%` } });
      }

      where.and.push({ or });
    }

    if (dateRange?.length) {
      const and = [
        {
          transactionDate: {
            between: dateRange,
          },
        },
      ];
      where.and.push({ and });
    }

    const url = `${this.coreApi}/PaymentTransactions/count?where=${encodeURIComponent(JSON.stringify(where))}`;
    return this.http.get(url, {});
  }

  getTransactionHistory(
    id,
    pageIndex,
    pageSize,
    selectedTypes,
    dateRange: any,
    value?: string,
    isExport?: boolean
  ): Observable<any> {
    const filter: any = {
      order: ['transactionDate DESC'],
      where: {
        and: [],
      },
      limit: isExport ? null : pageSize,
      skip: isExport ? 0 : (pageIndex - 1) * pageSize,
    };

    const or = selectedTypes.map(type => {
      if (type == TNX_PRODUCT_MAP.autocharge) {
        return { and: [{ productId: { eq: type } }, { description: { eq: 'Auto-Charging' } }] };
      } else {
        return { productId: { eq: type } };
      }
    });

    filter.where.and.push({ or });
    if (id && id > 1) {
      filter.where.and.push({ customerId: id });
    }

    if (value && value != '') {
      const or: any[] = [{ description: { like: `%${value}%` } }];
      // @ts-ignore
      if (!isNaN(value)) {
        or.push({ amount: parseFloat(value) });
      }

      filter.where.and.push({ or });
    }

    if (dateRange?.length) {
      const and = [
        {
          transactionDate: {
            between: dateRange,
          },
        },
      ];
      filter.where.and.push({ and });
    }

    const url = `${this.coreApi}/PaymentTransactions?filter=${encodeURIComponent(JSON.stringify(filter))}`;

    return this.http.get(url, {});
  }

  // Combined method to get both count and data in parallel for better performance
  getTransactionHistoryWithCount(
    id,
    pageIndex,
    pageSize,
    selectedTypes,
    dateRange: any,
    value?: string
  ): Observable<{ count: number; data: any[] }> {
    const countRequest = this.getTransactionHistoryCount(id, dateRange, selectedTypes, value);
    const dataRequest = this.getTransactionHistory(id, pageIndex, pageSize, selectedTypes, dateRange, value);

    // Make both requests in parallel using forkJoin for optimal performance
    return forkJoin({
      countResult: countRequest,
      dataResult: dataRequest,
    }).pipe(
      map(({ countResult, dataResult }) => ({
        count: (countResult as any).count,
        data: dataResult,
      }))
    );
  }

  getCallChargeSummary(startDate: string, endDate: string, customerId?: number) {
    return this.http.post(`${this.coreApi}/PaymentTransactions/callChargeSummary`, { startDate, endDate, customerId });
  }

  getPaymentHistoryById(id: string | number): Observable<any> {
    const url = `${this.coreApi}/PaymentTransactions/${id}`;
    return this.http.get<any>(url).pipe(timeout(5000));
  }

  /**
   * Get call logs count
   */
  getCallLogsCount(id, value?: string) {
    const where: any = {
      and: [{ customerId: id }, { productId: 6 }],
    };

    if (value && value != '') {
      const or: any[] = [{ description: { like: `%${value}%` } }];
      // @ts-ignore
      if (!isNaN(value)) {
        or.push({ amount: parseFloat(value) });
      }

      where.and.push({ or });
    }

    return this.http.get(
      `${this.coreApi}/PaymentTransactions/count?where=${encodeURIComponent(JSON.stringify(where))}`,
      {}
    );
  }

  /**
   * Get call logs
   */
  getCallLogs(id, pageIndex, pageSize, value?: string): Observable<any> {
    const filter: any = {
      order: ['transactionDate DESC'],
      where: {
        and: [{ customerId: id }, { productId: 6 }],
      },
      limit: pageSize,
      skip: (pageIndex - 1) * pageSize,
    };

    if (value && value != '') {
      const or: any[] = [{ description: { like: `%${value}%` } }];
      // @ts-ignore
      if (!isNaN(value)) {
        or.push({ amount: parseFloat(value) });
      }

      filter.where.and.push({ or });
    }

    return this.http.get(
      `${this.coreApi}/PaymentTransactions?filter=${encodeURIComponent(JSON.stringify(filter))}`,
      {}
    );
  }

  /**
   * Get transactions count
   */
  getTransactionsCount(id, selectedTypes, value?: string) {
    const where: any = {
      and: [],
    };

    const or = selectedTypes.map(type => {
      if (type == TNX_PRODUCT_MAP.autocharge) {
        return { and: [{ productId: { eq: type } }, { description: { eq: 'Auto-Charging' } }] };
      } else {
        return { productId: { eq: type } };
      }
    });

    where.and.push({ or });
    if (id) {
      where.and.push({ customerId: id });
    }

    if (value && value != '') {
      const or: any[] = [{ description: { like: `%${value}%` } }];
      // @ts-ignore
      if (!isNaN(value)) {
        or.push({ amount: parseFloat(value) });
      }

      where.and.push({ or });
    }

    return this.http.get(
      `${this.coreApi}/PaymentTransactions/count?where=${encodeURIComponent(JSON.stringify(where))}`,
      {}
    );
  }

  /**
   * Get transactions
   */
  getTransactions(id, selectedTypes, pageIndex, pageSize, value?: string): Observable<any> {
    const filter: any = {
      order: ['transactionDate DESC'],
      where: {
        and: [],
      },

      limit: pageSize,
      skip: (pageIndex - 1) * pageSize,
    };

    const or = selectedTypes.map(type => {
      if (type == TNX_PRODUCT_MAP.autocharge) {
        return { and: [{ productId: { eq: type } }, { description: { eq: 'Auto-Charging' } }] };
      } else {
        return { productId: { eq: type } };
      }
    });

    filter.where.and.push({ or });
    if (id) {
      filter.where.and.push({ customerId: id });
    }

    if (value && value != '') {
      const or: any[] = [{ description: { like: `%${value}%` } }];
      // @ts-ignore
      if (!isNaN(value)) {
        or.push({ amount: parseFloat(value) });
      }

      filter.where.and.push({ or });
    }

    return this.http.get(
      `${this.coreApi}/PaymentTransactions?filter=${encodeURIComponent(JSON.stringify(filter))}`,
      {}
    );
  }

  /**
   * Get price discounts list
   */
  getPriceDiscounts(): Observable<any> {
    return this.http.get(`${this.coreApi}/PriceDiscounts`, {});
  }

  /**
   * Charge customer
   */
  chargeCustomer(amount, payment_token): Observable<any> {
    return this.http.post(`${this.coreApi}/PaymentMethods/charge_customer`, {
      amount: amount,
      payment_token: payment_token,
    });
  }

  /**
   * Charge customer by admin
   */
  chargeCustomerByAdmin(amount, payment_token, customerId, description): Observable<any> {
    if (!payment_token || payment_token.trim().length == 0) payment_token = undefined;
    if (!description || description.trim().length == 0) description = 'Manual charge by admin user';
    return this.http.post(`${this.coreApi}/PaymentMethods/charge_customer`, {
      amount: amount,
      payment_token: payment_token,
      customerId: customerId,
      description: description,
    });
  }

  // =====================
  // User Registration
  // =====================

  /**
   * Request verification code on new user email
   */
  request_email(email: string, type?: string): Observable<any> {
    return this.http.post(`${this.coreApi}/DashUsers/request_email`, { email_address: email, email_type: type });
  }

  /**
   * Verify new user email
   */
  verify_email(email: string, verify_code: string): Observable<any> {
    return this.http.post(`${this.coreApi}/DashUsers/verify_email`, { email_address: email, verify_code: verify_code });
  }

  /**
   * Register new user
   */
  register(userdata): Observable<any> {
    return this.http.post(`${this.coreApi}/DashUsers/register`, userdata);
  }

  /**
   * Delete customer products relationship by condition
   */
  deleteCustomerProductsRelByWhere(where: string) {
    return this.http.delete<any>(`${this.coreApi}/CustomerProductsRels?where=${where}`);
  }

  // =====================
  // Blacklist Management
  // =====================

  /**
   * Add blacklist number
   */
  addBlacklistNumber(data: any): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/BlacklistNumbers`, data);
  }

  /**
   * Delete blacklist number by ID
   */
  deleteBlacklistNumber(id): Observable<any> {
    return this.http.delete<any>(`${this.coreApi}/BlacklistNumbers/${id}`);
  }

  /**
   * Get blacklist numbers
   */
  getBlacklistNumber(customerId): Observable<IBlacklistNumber[]> {
    let filter = '{}';
    if (customerId != 1) filter = `{ "where": {"or": [{"customerId": 1}, {"customerId": ${customerId} }] } }`;

    const url = `${this.coreApi}/BlacklistNumbers?filter=${filter}`;
    return this.http.get<IBlacklistNumber[]>(url);
  }

  // =====================
  // Subscription Management
  // =====================

  /**
   * Get subscriptions
   */
  getSubscriptions(): Observable<any[]> {
    const url = `${this.coreApi}/PaymentMethods/subscriptions`;
    return this.http.get<any[]>(url);
  }

  /**
   * Get subscription detail
   */
  getSubscriptionDetail() {
    const url = `${this.coreApi}/PaymentMethods/subscriptionDetail`;
    return this.http.get<any[]>(url);
  }

  pauseTrackingCode(): Observable<any> {
    const url = `${this.coreApi}/PaymentMethods/pause_tracking_code`;
    return this.http.post<any>(url, {});
  }

  /**
   * Stop incoming calls
   */
  stopIncomingCalls(): Observable<any> {
    const url = `${this.coreApi}/PaymentMethods/stop_incoming_calls`;
    return this.http.post<any>(url, {});
  }

  /**
   * Reactivate account
   */
  reactivateAccount(): Observable<any> {
    const url = `${this.coreApi}/PaymentMethods/reactive_account`;
    return this.http.post<any>(url, {});
  }

  /**
   * Save consent changes
   */
  saveChanges(payload: any): Observable<any> {
    const url = `${this.coreApi}/PaymentMethods/save_consent`;
    return this.http.put<any>(url, payload);
  }

  // =====================
  // Dialog Management
  // =====================

  /**
   * Get the list of dialogs in the system
   */
  getDialogs(): Observable<Calls[]> {
    return this.http.get<Calls[]>(`${this.coreApi}/Dialogs`);
  }

  // =====================
  // Audit Logs
  // =====================

  /**
   * Get audit logs
   */
  getAuditLogs(filters): Observable<HttpResponse<any[]>> {
    const filterParams = 'filter=' + encodeURIComponent(JSON.stringify(filters));
    return this.http.get<GetNumbers[]>(`${this.coreApi}/AuditLogs?${filterParams}`, { observe: 'response' });
  }

  /**
   * Get audit logs count
   */
  getAuditLogsCount(filters): Observable<any> {
    const filterParams = 'where=' + encodeURIComponent(JSON.stringify(filters.where));
    return this.http.get<any>(`${this.coreApi}/AuditLogs/count?${filterParams}`);
  }

  /**
   * Get pending email signup requests
   */
  getPendingSignups(filters): Observable<HttpResponse<any[]>> {
    const filterParams = 'filter=' + encodeURIComponent(JSON.stringify(filters));
    return this.http.get<any[]>(`${this.coreApi}/DashUsers/pending_signups?${filterParams}`, { observe: 'response' });
  }

  /**
   * Get pending email signup request count
   */
  getPendingSignupsCount(filters): Observable<any> {
    const filterParams = 'where=' + encodeURIComponent(JSON.stringify(filters.where));
    return this.http.get<any>(`${this.coreApi}/DashUsers/pending_signups/count?${filterParams}`);
  }

  updatePendingSignup(id: number, data: any): Observable<any> {
    return this.http.patch<any>(`${this.coreApi}/DashUsers/pending_signups/${id}`, data);
  }

  removePendingSignup(id: number): Observable<any> {
    return this.http.delete<any>(`${this.coreApi}/DashUsers/pending_signups/${id}`);
  }

  /**
   * Get the number of current dialogs in the system
   */
  getDialogsCount(): Observable<Calls[]> {
    return this.http.get<Calls[]>(`${this.coreApi}/Dialogs/count`);
  }

  /**
   * Setup card intent
   */
  setupCardIntent() {
    return this.http.post<string>(`${this.coreApi}/PaymentMethods/setup_card_intent`, {});
  }

  // =====================
  // IVR Management
  // =====================

  /**
   * Save IVR
   */
  public saveIvr(payload): Observable<IVR> {
    return this.http.post<IVR>(`${this.coreApi}/Ivrs`, payload);
  }

  /**
   * Save IVR actions
   */
  public saveIvrActions(id: number, payload): Observable<any> {
    return this.http.post<any>(`${this.coreApi}/Ivrs/${id}/Actions`, payload);
  }

  /**
   * Get all IVRs
   */
  public getAllIvrs(customerFilter?): Observable<IVR[]> {
    if (customerFilter != null) {
      customerFilter = encodeURIComponent(JSON.stringify(customerFilter));
      return this.http.get<IVR[]>(`${this.coreApi}/Ivrs?filter=${customerFilter}`);
    } else {
      return this.http.get<IVR[]>(`${this.coreApi}/Ivrs`);
    }
  }

  /**
   * Get all IVRs count
   */
  public getAllIvrsCount(customerFilter?): Observable<IVR[]> {
    if (customerFilter) {
      customerFilter = encodeURIComponent(JSON.stringify(customerFilter));
      customerFilter = `?where=${customerFilter}`;
    } else {
      customerFilter = '';
    }
    return this.http.get<IVR[]>(`${this.coreApi}/Ivrs/count${customerFilter}`);
  }

  /**
   * Get IVRs for filters/dropdowns (id/name/description only).
   * Hits the lightweight LightIvr endpoint which maps to the same `ivr`
   * table but omits the Actions include and the root_payload / root_audio
   * blobs — only load the full IVR (getIvrById) when the editor needs it.
   */
  public getIvrFilters(filter?): Observable<IVR[]> {
    if (filter != null) {
      const query = encodeURIComponent(JSON.stringify(filter));
      return this.http.get<IVR[]>(`${this.coreApi}/LightIvrs?filter=${query}`);
    }
    return this.http.get<IVR[]>(`${this.coreApi}/LightIvrs`);
  }

  /**
   * Count IVRs via the lightweight filters endpoint.
   */
  public getIvrFiltersCount(where?): Observable<any> {
    if (where) {
      const query = encodeURIComponent(JSON.stringify(where));
      return this.http.get<any>(`${this.coreApi}/LightIvrs/count?where=${query}`);
    }
    return this.http.get<any>(`${this.coreApi}/LightIvrs/count`);
  }

  /**
   * Get IVR by ID
   */
  public getIvrById(id: number): Observable<IVR> {
    return this.http.get<IVR>(`${this.coreApi}/Ivrs/${id}`);
  }

  /**
   * Update IVR
   */
  public updateIvr(id, payload): Observable<IVR> {
    return this.http.put<IVR>(`${this.coreApi}/Ivrs/${id}`, payload);
  }

  /**
   * Update IVR actions
   */
  public updateIvrActions(ivrId: number, id: number, payload): Observable<any> {
    return this.http.put<any>(`${this.coreApi}/Ivrs/${ivrId}/Actions/${id}`, payload);
  }

  /**
   * Delete IVR actions by ID
   */
  public deleteIvrActionsById(ivrId: number, id: number): Observable<any> {
    return this.http.delete<any>(`${this.coreApi}/Ivrs/${ivrId}/Actions/${id}`);
  }

  /**
   * Delete IVR by ID
   */
  public deleteIvrById(id: number): Observable<IVR> {
    return this.http.delete<IVR>(`${this.coreApi}/Ivrs/${id}`);
  }

  /**
   * Delete IVR actions
   */
  public deleteIvrActions(ivrId: number): Observable<any> {
    return this.http.delete<any>(`${this.coreApi}/Ivrs/${ivrId}/Actions`);
  }

  getCustomerSipConnections(customerId: number) {
    return this.http.get<any[]>(this.coreApi + '/Customers/sipConnections?customerId=' + customerId);
  }
  getSipInterfaces() {
    return this.http.get<any[]>(this.coreApi + '/Customers/sipInterfaces');
  }
  createSipInterface(input: any) {
    return this.http.post<any>(this.coreApi + '/Customers/sipInterfaces', input);
  }
  getCustomerSipInterfaceAssignment(customerId: number) {
    return this.http.get<any>(this.coreApi + '/Customers/sipInterfaceAssignment?customerId=' + customerId);
  }
  assignCustomerSipInterface(customerId: number, interfaceId: number) {
    return this.http.post<any>(this.coreApi + '/Customers/sipInterfaceAssignment?customerId=' + customerId, {
      interfaceId,
    });
  }
  unassignCustomerSipInterface(customerId: number) {
    return this.http.delete<any>(this.coreApi + '/Customers/sipInterfaceAssignment?customerId=' + customerId);
  }
  getCustomerSipEligibility(customerId: number) {
    return this.http.get<any>(this.coreApi + '/Customers/sipEligibility?customerId=' + customerId);
  }
  saveCustomerSipConnection(customerId: number, id: number | null, input: any) {
    const path =
      this.coreApi + '/Customers/sipConnections' + (id == null ? '' : '/' + id) + '?customerId=' + customerId;
    return id == null ? this.http.post<any>(path, input) : this.http.put<any>(path, input);
  }
  setCustomerSipConnectionEnabled(customerId: number, id: number, enabled: boolean) {
    return this.http.post<any>(this.coreApi + '/Customers/sipConnections/' + id + '/enabled?customerId=' + customerId, {
      enabled,
    });
  }
  assignCustomerSipNumber(customerId: number, id: number, numberId: number) {
    return this.http.post<any>(this.coreApi + '/Customers/sipConnections/' + id + '/number?customerId=' + customerId, {
      numberId,
    });
  }
  getCustomerConnections(customerId?: number) {
    const query = customerId === undefined ? '' : '?customerId=' + encodeURIComponent(String(customerId));
    return this.http.get<any[]>(this.coreApi + '/Customers/accountConnections' + query);
  }

  getCustomerInvoiceHistory(after?: string | null, customerId?: number) {
    const params = new URLSearchParams();
    if (after) params.set('after', after);
    if (customerId !== undefined) params.set('customerId', String(customerId));
    const query = params.toString() ? '?' + params.toString() : '';
    return this.http.get<any>(this.coreApi + '/PaymentMethods/customerInvoiceHistory' + query);
  }

  getInvoicesDetail(startDate?: any, endDate?: any) {
    let data: any = {};

    if (startDate) {
      data = { startDate };

      if (endDate) {
        data.endDate = endDate;
      }
    }

    return this.http.post(`${this.coreApi}/PaymentMethods/getCustomerInvoice`, data);
  }

  getAgreement(key: string): Observable<any> {
    return this.http.get<any>(
      `${this.coreApi}/SystemSettings?filter=${encodeURIComponent(
        JSON.stringify({
          where: { key },
        })
      )}`
    );
  }

  /**
   * Get default system settings
   */
  getDefaultSystemSettings(): Observable<any> {
    return this.http.get<any>(`${this.coreApi}/SystemSettings/defaultSettings`);
  }

  /**
   * Update agreement
   */
  public updateAgreement(id, payload): Observable<any> {
    if (id) {
      return this.http.put<any>(`${this.coreApi}/SystemSettings/${id}`, payload);
    } else {
      return this.http.post<any>(`${this.coreApi}/SystemSettings`, payload);
    }
  }

  lookupZipCode(zipCode: string, countryCode: string): Observable<any> {
    return this.http.get<any>(`https://api.zippopotam.us/${countryCode}/${zipCode}`);
  }
}
